
import { useState, useEffect, useRef, useMemo } from "react";
import "../../SalesMasterPages/ViewLeadDetail/ViewLeadDetail.css";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import axios from "axios";
import Wrapper from "../../../components/UI/Wrapper";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import images2 from "../../../images/no_image.jpg";
import mailIcon from "../../../Icons/mail.png";
import CryptoJS from "crypto-js";
import GooglePlacesAutocomplete from "react-google-autocomplete";
import Multiselect from "multiselect-react-dropdown";
import JSZip from "jszip";
import LeadPaymentDetails from "../../../components/LeadPaymentDetails/LeadPaymentDetails";
import LeadDocuments from "../../../components/LeadDocuments/LeadDocuments";
import whatsappIcon from "../../../images/whatsappIcon.svg";
import LeadExpenseList from "../../../components/LeadExpenseList/LeadExpenseList";
import "react-toastify/dist/ReactToastify.css";
import SendMailWithPdf from "../../../components/SendMailWithPdf/SendMailWithPdf";
import LeadRefundDetails from "../../../components/LeadRefundDetails/LeadRefundDetails";
import LeadBillingDetails from "../../../components/LeadBillingDetails/LeadBillingDetails";
import { validateFormByServiceType, isFieldRequired, markRequiredFields } from './service_validation';
import PetDetailsEditor from "./PetDetailsEditor";

const ViewLeadDetails = () => {
    const [isEditMode, setIsEditMode] = useState(false);

    const [leadDetailResponse, setLeadDetailResponse] = useState([]);
    const [leadOwnerResponse, setLeadOwnerResponse] = useState([]);
    const navigate = useNavigate(); // State for the Navigation list
    const [relocation_date1, setRelocation_date1] = useState("");
    const [originCityCodeResponse, setOriginCityCodeResponse] = useState([]);
    const [destinationCityCodeResponse, setDestinationCityCodeResponse] =
        useState([]);
    const [airlinePopupData, setAirlinePopupData] = useState([]);
    const [trainPopupData, setTrainPopupData] = useState([]);
    const location = useLocation();
    const [leadUpdate, setLeadUpdate] = useState([]);
    const [followup, setFollowup] = useState([]);
    const [ivrDetail, setIvrDetail] = useState([]);
    const [mailDetail, setMailDetail] = useState([]);
    const [petDetail, setPetDetail] = useState([]);
    const [pets, setPets] = useState([]);

    // --------start of Add Lead-------------------------
    const [assignToResponse, setAssignToResponse] = useState([]);
    const [petTypeResponse, setPetTypeResponse] = useState([]);
    const [petBreedResponse, setPetBreedResponse] = useState([]);
    const [deliveryTypeResponse, setDeliveryTypeResponse] = useState([]);
    const [originCountryResponse, setOriginCountryResponse] = useState([]);
    const [destinationCountryResponse, setDestinationCountryResponse] = useState(
        []
    );
    const [originStateResponse, setOriginStateResponse] = useState([]);
    const [destinationStateResponse, setDestinationStateResponse] = useState([]);
    const [originCityResponse, setOriginCityResponse] = useState([]);
    const [destinationCityResponse, setDestinationCityResponse] = useState([]);
    const [openleadstageResponse, setOpenleadstageResponse] = useState([]);
    const [closeleadstageResponse, setCloseleadstageResponse] = useState([]);
    const [serviceTypeResponse, setServiceTypeResponse] = useState([]);
    const [leadLabelResponse, setLeadLabelResponse] = useState([]);
    const [convertedleadstageResponse, setConvertedleadstageResponse] = useState(
        []
    );
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [subStageResponse, setSubStageResponse] = useState([]);
    const [decryptionError, setDecryptionError] = useState(false);
    const isAdmin = localStorage.getItem("isAdmin") === "true";
    const userName = localStorage.getItem("name");
    const [paymentDetail, setPaymentDetail] = useState([]);
    const [selectedMailDetail, setSelectedMailDetail] = useState();
    //----------------------------------------------//
    const baseAPI = process.env.REACT_APP_API_URL;

    const baseImageURL = process.env.REACT_APP_IMAGE_URL;

    const [showModal, setShowModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");
    const [currency, setCurrency] = useState("");

    const [documentResponse, setDocumentResponse] = useState(null);
    const [documentType, setDocumentType] = useState([]);
    const fileInputRef = useRef(null);
    const [isDisabled, setIsDisabled] = useState(false);
    const [airlineNameResponse, setAirlineNameResponse] = useState([]);
    const [activeTab, setActiveTab] = useState("Lead Details");
    const tabs = ["Lead Details", "Documents", "Payment Details", "Refund & Cancellation", "Billing Details"];
    const tabRefs = useRef([]); // To store refs for each tab
    const [indicatorStyle, setIndicatorStyle] = useState({});
    const tabContainerRef = useRef(null);

    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);
    const [showExpenseModal, setShowExpenseModal] = useState(false);
    const [estimateDetail, setEstimateDetail] = useState([]);
    const goToAddExpense = () => {
        setShowExpenseModal(true);
    };

    const closeExpenseModal = () => {
        setShowExpenseModal(false);
    };



    const handleImageClick = (imageSrc) => {
        // alert(imageSrc);
        setSelectedImage(imageSrc);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };
    //----------------------------------------------//

    // --------------------add data section starts here-------------------
    // -------for relocation detail pop-up ----------------


    const [firstItem, setFirstItem] = useState({
        relocation_id: "",

        relocation_date: "",
        first_name: "",
        last_name: "",
        email: "",
        sub_category: "",
        mobile_no: "",
        subject: "",
        message: "",
        service_type: "",
        where_did_you_find_us: "",
        referral_url: "",
        job_type: "",
        whatsapp_title: "",
        lead_label: "",
        relocationdetail_id: "",
        origin_country: "",
        origin_state: "",
        origin_city: "",
        origin_pin: "",
        destination_country: "",
        destination_state: "",
        destination_city: "",
        destination_pin: "",
        available_slot: "",
        mode_of_transport: "",
        origin_address: "",
        destination_address: "",
        origin_contact_person: "",
        destination_contact_person: "",
        origin_contact_no: "",
        destination_contact_no: "",
        origin_city_code: "",
        destination_city_code: "",
        delivery_type: "",
        distance: "",
        distance2: "",
        price: "",
        relocation_detail: "",
        airline_id: "",
        flight_number: "",
        departure_time: "",
        arrival_time: "",
        airlines_rate: "",
        baggage_type: "",

        petdetail_id: "",
        pet_name: "",
        pet_type: "",
        pet_breed: "",
        number_of_pets: "",
        pet_length: "",
        pet_width: "",
        pet_height: "",
        container_length: "",
        pet_dob: "",

        pet_age: "",
        pet_weight: "",
        chargeable_wt: "",
        crate_size: "",
        pet_photo_standing: "",
        pet_photo_sitting: "",
        vaccinationbook_front: "",
        vaccinationbook_back: "",

        nextfollowupdatetime: "",
        openleadstage: "",
        closedleadstage: "",
        convertedstatus: "",
        assignto: "",
        staff_view: "",
        remark: "",
        followup_remark: "",

        gender: "",
        relocation_purpose: "",
        alternate_number: "",
        pet_gender: "",
        pet_behaviour: "",

        Quotation: "",
        Amount_In_AED: "",
        Payment_Ter: "",
        Token_Payment: "",
        Remaining_Payment: "",
        Pymt_Status: "",
        Payment_Mode: "",
        Estimate_Id: "",
        GST: "",
        amount_exc_gst: "",
        awb_number: "",

        origin_port: "",
        destination_port: "",
        rate: "0",
        train_name_number: "",
        customer_type: "",
        user_id: "",


    });
    const canShow = isAdmin || (firstItem && firstItem.name === userName);
    const [documentsUpload, setDocumentsUpload] = useState({
        client_doc_id: "",
        relocation_id: "",
        document_type: "",
        remarkDoc: "",
        doc_path: "",
        doc_name: "",
        priority_upload: "2",
    });

    const [vaccinationBookFront, setVaccinationBookFront] = useState(null);
    const [vaccinationBookBack, setVaccinationBookBack] = useState(null);
    const [petPhotosSitting, setPetPhotosSitting] = useState(null);
    const [petPhotosStanding, setPetPhotosStanding] = useState(null);


    function decryptRelocationID(ciphertext) {
        try {
            const bytes = CryptoJS.AES.decrypt(
                decodeURIComponent(ciphertext),
                "dbbworldwidepvtltd"
            );
            return bytes.toString(CryptoJS.enc.Utf8);
        } catch (error) {
            console.error("Error decrypting Relocation_ID:", error);
            setDecryptionError(true);

            return null;
        }
    }

    function getStatusColor(statusName) {
        switch (statusName) {
            case "Untouched":
                return "orange";
            case "Open":
                return "#28A745";
            case "Closed":
                return "#DC3545";
            case "Converted":
                return "#87CEEB";
            default:
                return "white";
        }
    }

    const [hoveredItem, setHoveredItem] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState({});

    const handleMouseEnter = (item, event) => {
        setTooltipPosition({
            top: event.clientY + 10,
            left: event.clientX + 10,
        });
        setHoveredItem(item);
    };

    const handleMouseLeave = () => {
        setHoveredItem(null);
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const encryptedRelocationID = searchParams.get("Relocation_ID");
        const Relocation_ID = decryptRelocationID(encryptedRelocationID);

        setFirstItem((prevItem) => ({
            ...prevItem,
            relocation_id: Relocation_ID,
        }));

        const storedToken = JSON.parse(localStorage.getItem("token"));
        if (baseAPI.includes("aeapi")) {
            setCurrency("INR");
        } else {
            setCurrency("AED");
        }
        if (storedToken) {
            const headers = { Authorization: `Bearer ${storedToken}` };
            axios
                .get(`${baseAPI}userget/GetLeadDetail?relocation_id=` + Relocation_ID, {
                    headers: {
                        Authorization: `Bearer ${storedToken}`,
                    },
                })
                .then((response) => {

                    setLeadDetailResponse(response.data.data);
                    setFirstItem(response.data.data);

                    setPetDetail(response.data.data.petsDetail);
                    setLeadUpdate(response.data.data.leadUpdatedetail);
                    setFollowup(response.data.data.followupDetail);
                    setIvrDetail(response.data.data.ivrDetail);
                    setMailDetail(response.data.data.mailDetail);
                    setEstimateDetail(response.data.data.estimateDetail)
                    getServiceType();
                    getCountry();
                    getState(response.data.data.origin_country, 1);
                    getState(response.data.data.destination_country, 2);
                    getCity(response.data.data.origin_state, 1);
                    getCity(response.data.data.destination_state, 2);

                    getPetType(headers);
                    getPetBreed(0, headers);

                    getLeadStage(1);
                    getLeadStage(2);
                    getLeadStage(3);
                    getAirlinesName();
                    getEmployeeByDepartment();
                    getLeadOwner(Relocation_ID);
                    getLeadLabel();
                    setVaccinationBookFront(
                        `${baseImageURL}${response.data.data.petsDetail[0].vaccinationbook_front}`
                    );
                    setVaccinationBookBack(
                        `${baseImageURL}${response.data.data.petsDetail[0].vaccinationbook_back}`
                    );
                    setPetPhotosSitting(
                        `${baseImageURL}${response.data.data.petsDetail[0].pet_photo_standing}`
                    );
                    setPetPhotosStanding(
                        `${baseImageURL}${response.data.data.petsDetail[0].pet_photo_sitting}`
                    );

                    setFirstItem((prevItem) => ({
                        ...prevItem,
                        pet_name: response.data.data.petsDetail[0].pet_name,
                        pet_behaviour: response.data.data.petsDetail[0].pet_behaviour,
                        container_length: response.data.data.petsDetail[0].container_length,
                        relocationdetail_id:
                            response.data.data.relocationdetail[0].relocationdetail_id,
                        petdetail_id: response.data.data.petsDetail[0].petdetail_id,
                        pet_dob: response.data.data.petsDetail[0].pet_dob,
                        pet_age: response.data.data.petsDetail[0].pet_age,
                        pet_weight: response.data.data.petsDetail[0].pet_weight,
                        chargeable_wt: response.data.data.petsDetail[0].chargeable_wt,
                        crate_size: response.data.data.petsDetail[0].crate_size,
                    }));

                    setRelocationData(response.data.data.relocationdetail[0]);

                    if (
                        response.data.data.leadUpdatedetail != null &&
                        response.data.data.leadUpdatedetail != ""
                    ) {
                        setLUD(response.data.data.leadUpdatedetail[0]);
                    }

                    if (
                        response.data.data.paymentDetail != null &&
                        response.data.data.paymentDetail != "" &&
                        response.data.data.status == 3
                    ) {
                        setPaymentDetail({ ...response.data.data.paymentDetail[0], relocation_id: Relocation_ID });
                    } else if (
                        response.data.data.secpaymentDetail != null &&
                        response.data.data.secpaymentDetail != ""
                    ) {
                        setPaymentDetail({ ...response.data.data.secpaymentDetail[0], relocation_id: Relocation_ID });
                    }

                    chekDisableEnable(response.data.data.status);
                })
                .catch((error) => {
                    console.error("Error fetching user detail:", error);
                });

            axios
                .get(
                    `${baseAPI}userget/GetClientDocuments?relocation_id=` +
                    Relocation_ID +
                    `&option=2`,
                    {
                        headers: {
                            Authorization: `Bearer ${storedToken}`,
                        },
                    }
                )
                .then((response) => {
                    if (response) {
                        setDocumentResponse(response.data.data);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching user detail:", error);
                });

            axios
                .get(`${baseAPI}userget/GetDocumentType?service_type=0&user_type=0`, {
                    headers: {
                        Authorization: `Bearer ${storedToken}`,
                    },
                })
                .then((response) => {
                    if (response) {
                        setDocumentType(response.data.data.map((Name) => ({ Name })));
                    }
                })
                .catch((error) => {
                    console.error("Error fetching user detail:", error);
                });
        }

        const updateIndicatorStyles = () => {
            const currentTabIndex = tabs.indexOf(activeTab);
            const currentTabRef = tabRefs.current[currentTabIndex];

            if (currentTabRef) {
                // Adjust offset to correct for extra padding/margins
                const containerOffset = tabContainerRef.current.offsetLeft || 0;

                setIndicatorStyle({
                    width: `${currentTabRef.offsetWidth}px`,
                    transform: `translateX(${currentTabRef.offsetLeft - containerOffset
                        }px)`,
                });
            }
        };
        updateIndicatorStyles();
    }, [activeTab, location.search]);

    useEffect(() => {
        if (leadDetailResponse?.petsDetail?.length) {
            setPets(leadDetailResponse.petsDetail.map((p) => ({ ...p })));
        } else {
            setPets([{}]);
        }
    }, [leadDetailResponse?.petsDetail]);


    // tab underline indicator (unchanged in spirit)
    useEffect(() => {
        const currentTabIndex = tabs.indexOf(activeTab);
        const currentTabRef = tabRefs.current[currentTabIndex];
        if (currentTabRef && tabContainerRef.current) {
            const containerOffset = tabContainerRef.current.offsetLeft || 0;
            setIndicatorStyle({
                width: `${currentTabRef.offsetWidth}px`,
                transform: `translateX(${currentTabRef.offsetLeft - containerOffset}px)`,
            });
        }
    }, [activeTab]);


    // ------------------- API helpers -------------------
    function getPetType(headers) {
        axios
            .get(`${baseAPI}userget/GetPetType`, { headers })
            .then((res) => setPetTypeResponse(res?.data?.data || []))
            .catch((e) => console.error("GetPetType error", e));
    }


    // If typeId === 0 -> fetch ALL breeds
    function getPetBreed(typeId, headers) {
        axios
            .get(`${baseAPI}userget/GetPetBreed?PetType=${typeId || 0}`, { headers })
            .then((res) => setPetBreedResponse(res?.data?.data || []))
            .catch((e) => console.error("GetPetBreed error", e));
    }


    // Local mapping helpers for view mode
    const petTypeName = useMemo(
        () => (id) =>
            (petTypeResponse || []).find((t) => String(t.pettype) === String(id))?.pettype_name || id,
        [petTypeResponse]
    );


    const petBreedName = useMemo(
        () => (id) =>
            (petBreedResponse || []).find((b) => String(b.PetBreedID || b.petbreedid) === String(id))
                ?.BreedName || id,
        [petBreedResponse]
    );


    // Breed options provider for editor (filters from the all-breeds list)
    const getPetBreedOptions = useMemo(
        () => (typeId) => (petBreedResponse || []).filter((b) => String(b.PetType) === String(typeId)),
        [petBreedResponse]
    );



    const formatDate = (dateString) => {
        const options = {
            day: "numeric",
            month: "short",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: true,
        };

        const formattedDate = new Date(dateString).toLocaleString("en-US", options);
        return formattedDate;
    };


    function getDeliveryType(mode) {
        if (mode != null && mode !== "") {
            // 👇 Check if mode is 3 and set delivery_type directly
            if (mode === 3 || mode === "3") {
                setFirstItem((prev) => ({
                    ...prev,
                    delivery_type: 9,
                }));
            }

            const storedToken = JSON.parse(localStorage.getItem("token"));
            axios
                .get(`${baseAPI}userget/GetDeliveryType?mode_of_transport=${mode}`, {
                    headers: {
                        Authorization: `Bearer ${storedToken}`,
                    },
                })
                .then((response) => {
                    setDeliveryTypeResponse(response.data.data);
                })
                .catch((error) => {
                    console.error("Error fetching user detail:", error);
                });
        }
    }

    function chekDisableEnable(status) {
        if (status === 3) {
            getLeadSubStage(47);
            setFirstItem((prevItem) => ({
                ...prevItem,
                closedleadstage: 47,
                sub_category: 55,
            }));
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }
    }

    function getCountry() {
        const storedToken = JSON.parse(localStorage.getItem("token"));

        axios
            .get(`${baseAPI}adminget/GETCountry?countryID=0`, {
                headers: {
                    Authorization: `Bearer ${storedToken}`,
                },
            })
            .then((response) => {
                setOriginCountryResponse(response.data.data);
                setDestinationCountryResponse(response.data.data);
            })
            .catch((error) => {
                console.error("Error fetching user detail:", error);
            });
    }

    function getServiceType() {
        const storedToken = JSON.parse(localStorage.getItem("token"));

        axios
            .get(`${baseAPI}adminget/GetServiceType`, {
                headers: {
                    Authorization: `Bearer ${storedToken}`,
                },
            })
            .then((response) => {
                setServiceTypeResponse(response.data.data);

            })
            .catch((error) => {
                console.error("Error fetching user detail:", error);
            });
    }

    function getLeadLabel() {
        const storedToken = JSON.parse(localStorage.getItem("token"));

        axios
            .get(`${baseAPI}adminget/GetLeadLabel?label_id=0`, {
                headers: {
                    Authorization: `Bearer ${storedToken}`,
                },
            })
            .then((response) => {

                setLeadLabelResponse(response.data.data);

            })
            .catch((error) => {
                console.error("Error fetching user detail:", error);
            });
    }

    function getState(country_id, type) {
        if (country_id != null && country_id != "0") {
            const storedToken = JSON.parse(localStorage.getItem("token"));
            axios
                .get(`${baseAPI}adminget/GETState?stateID=0&countryID=` + country_id, {
                    headers: {
                        Authorization: "Bearer " + storedToken,
                    },
                })
                .then((response) => {
                    if (type === 1) {
                        setOriginStateResponse(response.data.data);
                    } else if (type === 2) {
                        setDestinationStateResponse(response.data.data);
                    }
                });
        }
    }

    function getCity(state_id, type) {
        if (state_id != null && state_id != "0") {
            const storedToken = JSON.parse(localStorage.getItem("token"));
            axios
                .get(`${baseAPI}adminget/GETCity?cityID=0&stateID=` + state_id, {
                    headers: {
                        Authorization: "Bearer " + storedToken,
                    },
                })
                .then((response) => {
                    if (type === 1) {
                        setOriginCityResponse(response.data.data);
                    } else if (type === 2) {
                        setDestinationCityResponse(response.data.data);
                    }
                });
        }
    }

    function getPetType() {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        if (storedToken) {
            axios
                .get(`${baseAPI}adminget/GEPetType?PetType=0`, {
                    headers: {
                        Authorization: `Bearer ${storedToken}`,
                    },
                })
                .then((response) => {
                    setPetTypeResponse(response.data.data);
                })
                .catch((error) => {
                    console.error("Error fetching user detail:", error);
                });
        }
    }

    function getPetBreed(pet_type) {
        if (pet_type === null || pet_type === "") {
            pet_type = 0;
        }

        const storedToken = JSON.parse(localStorage.getItem("token"));
        axios
            .get(
                `${baseAPI}adminget/GEPetBreedType?PetBreedID=0&PetType=` + pet_type,
                {
                    headers: {
                        Authorization: "Bearer " + storedToken,
                    },
                }
            )
            .then((response) => {
                setPetBreedResponse(response.data.data);
            });
    }

    function getLeadStage(statusid) {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        axios
            .get(`${baseAPI}adminget/GETStages?StageID=0&StatusID=` + statusid, {
                headers: {
                    Authorization: "Bearer " + storedToken,
                },
            })
            .then((response) => {
                if (statusid === 1) {
                    setOpenleadstageResponse(response.data.data);
                } else if (statusid === 2) {
                    setCloseleadstageResponse(response.data.data);
                } else if (statusid === 3) {
                    setConvertedleadstageResponse(response.data.data);
                }
            });
    }

    function getLeadSubStage(stage_id) {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        axios
            .get(`${baseAPI}adminget/GETSubStages?stage_id=` + stage_id, {
                headers: {
                    Authorization: "Bearer " + storedToken,
                },
            })
            .then((response) => {
                setSubStageResponse(response.data.data);
            });
    }

    function getEmployeeByDepartment() {
        const storedToken = JSON.parse(localStorage.getItem("token"));

        axios
            .get(`${baseAPI}adminget/GETEmployeeByDepartment?department_id=3`, {
                headers: {
                    Authorization: `Bearer ${storedToken}`,
                },
            })
            .then((response) => {
                setAssignToResponse(response.data.data);
            })
            .catch((error) => {
                console.error("Error fetching user detail:", error);
            });
    }

    function getLeadOwner(relocation_id) {
        const storedToken = JSON.parse(localStorage.getItem("token"));

        axios
            .get(`${baseAPI}userget/GetOwnerLog?relocation_id=` + relocation_id, {
                headers: {
                    Authorization: `Bearer ${storedToken}`,
                },
            })
            .then((response) => {
                setLeadOwnerResponse(response.data.data);
            })
            .catch((error) => {
                console.error("Error fetching user detail:", error);
            });
    }

    function QuotationBuilderPage(relocation_id) {
        navigate("/QuotationBuilder", { state: { relocation_id: relocation_id } });
    }


    function isValidFileType(file) {
        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "application/pdf",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
            "application/vnd.ms-excel", // XLS
            "video/mp4",
            "video/x-msvideo", // AVI
            "video/x-matroska", // MKV
            "video/quicktime", // MOV
            "application/zip", // ZIP
            "application/x-zip-compressed", // Alternate ZIP MIME type
        ];
        return file && allowedTypes.includes(file.type);
    }

    function validateZipFile(file, name, e) {
        const reader = new FileReader();
        reader.onload = function (event) {
            const zipData = event.target.result;

            // Perform ZIP content validation here
            // This might include extracting the files, verifying file types, etc.
            // Client-side libraries like JSZip can help inspect ZIP files
            try {
                const jszip = new JSZip();
                jszip.loadAsync(zipData).then((zip) => {
                    const allowedExtensions = ["jpg", "png", "pdf", "docx", "xlsx"];
                    let isValid = true;

                    zip.forEach((relativePath, zipEntry) => {
                        const extension = relativePath.split(".").pop().toLowerCase();
                        if (!allowedExtensions.includes(extension)) {
                            isValid = false;
                        }
                    });

                    if (isValid) {
                        getUpdatedImage(file, name);
                    } else {
                        alert("ZIP file contains unsupported file types.");
                        e.target.value = null;
                    }
                });
            } catch (error) {
                alert("Error reading ZIP file.");
                e.target.value = null;
            }
        };

        reader.readAsArrayBuffer(file);
    }




    function getUpdatedImage(file, name) {
        if (file) {
            setDocumentsUpload({
                ...documentsUpload,
                [name]: file, // Store the file object directly
            });
        }
    }
    function getDocument(Relocation_ID) {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        if (storedToken) {
            axios
                .get(
                    `${baseAPI}userget/GetClientDocuments?relocation_id=` +
                    Relocation_ID +
                    `&option=2`,
                    {
                        headers: {
                            Authorization: `Bearer ${storedToken}`,
                        },
                    }
                )
                .then((response) => {
                    if (response) {
                        setDocumentResponse(response.data.data);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching user detail:", error);
                });
        }
    }

    function getAirlinesName() {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        if (storedToken) {
            axios
                .get(`${baseAPI}userget/GetAirlinesNames`, {
                    headers: {
                        Authorization: `Bearer ${storedToken}`,
                    },
                })
                .then((response) => {
                    if (response) {
                        setAirlineNameResponse(response.data.data);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching user detail:", error);
                });
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFirstItem((prevItem) => {
            let updatedItem = {
                ...prevItem,
                [name]: value,
            };

            if (name === "pet_dob") {
                updatedItem.pet_age = calculateAge(value);
            }

            if (name === "crate_size") {
                if (value === "CR82") {
                    updatedItem.chargeable_wt = "";
                } else if (value === "Soft Bag") {
                    updatedItem.chargeable_wt = 0;
                } else {
                    updatedItem.chargeable_wt = crateWeightMap[value] || prevItem.chargeable_wt;
                }
            }
            return updatedItem;
        });
    };


    const handleSelect = (place, field) => {
        setFirstItem((prevItem) => ({
            ...prevItem,
            [field]: place.formatted_address || "",
        }));
    };

    const handleChange4 = (event, field) => {
        setFirstItem((prevItem) => ({
            ...prevItem,
            [field]: event.target.value,
        }));
    };

    const handleChange3 = (e) => {
        const { name, value } = e.target;
        // Update the state and immediately pass the updated state to getDistance
        setFirstItem((prevItem) => {
            const updatedItem = {
                ...prevItem,
                [name]: value,
            };

            // Call getDistance with the updated state
            //getDistance_1(updatedItem);
            return updatedItem;
        });
    };

    const calculateAge = (dob) => {
        const dobDate = new Date(dob);
        const today = new Date();

        let years = today.getFullYear() - dobDate.getFullYear();
        let months = today.getMonth() - dobDate.getMonth();
        let days = today.getDate() - dobDate.getDate();

        // Adjust the calculation if the current month/day is before the birthday month/day
        if (days < 0) {
            months--;
            days += new Date(today.getFullYear(), today.getMonth(), 0).getDate(); // Get the last day of the previous month
        }

        if (months < 0) {
            years--;
            months += 12;
        }

        return `${years} years, ${months} months, ${days} days`;
    };

    const handleChange1 = (e) => {
        const { name, value } = e.target;
        setFirstItem((prevItem) => ({
            ...prevItem,
            [name]: value,
        }));
    };

    const handleServiceTypeChange = (e) => {
        const newServiceType = Number(e.target.value);

        setFirstItem((prevItem) => ({
            ...prevItem,
            service_type: newServiceType,
            mode_of_transport: [8, 10, 11, 12, 13, 14, 15].includes(newServiceType)
                ? 4
                : leadDetailResponse?.relocationdetail[0]?.mode_of_transport ?? prevItem.mode_of_transport
        }));
        // markRequiredFields(newServiceType);
    };



    const handleChange2 = (e) => {
        const { name, value } = e.target;
        // Update the state for the given field
        setFirstItem((prevItem) => {
            const updatedItem = {
                ...prevItem,
                [name]: value,
            };
            // Call handleCity with updated values
            handleCity(updatedItem);
            return updatedItem;
        });
    };

    const handleChangeOPenClose = (e) => {
        const { name, value } = e.target;
        setFirstItem((prevItem) => ({
            ...prevItem,
            [name]: value,
        }));
        getLeadSubStage(e.target.value);
        if (name === "openleadstage" && value !== "0") {
            setFirstItem((prevState) => ({
                ...prevState,
                closedleadstage: "0",
                sub_category: "0",
            }));
        } else if (name === "closedleadstage" && value !== "0") {
            setFirstItem((prevState) => ({
                ...prevState,
                openleadstage: "0",
                sub_category: "0",
            }));
        }
    };

    async function setRelocationData(e) {
        setFirstItem((prevItem) => ({
            ...prevItem,
            origin_country: e.origin_country,
            origin_state: e.origin_state,
            origin_city: e.origin_city,
            origin_pin: e.origin_pin,
            destination_country: e.destination_country,
            destination_state: e.destination_state,
            destination_city: e.destination_city,
            destination_pin: e.destination_pin,
            available_slot: e.available_slot,
            mode_of_transport: e.mode_of_transport,
            origin_address: e.origin_address,
            destination_address: e.destination_address,
            origin_contact_person: e.origin_contact_person,
            destination_contact_person: e.destination_contact_person,
            origin_contact_no: e.origin_contact_no,
            destination_contact_no: e.destination_contact_no,
            origin_city_code: e.origin_city_code,
            destination_city_code: e.destination_city_code,
            delivery_type: e.delivery_type,
            distance: e.distance,
            distance2: e.distance2,
            price: e.price,
            relocation_detail: e.relocation_detail,
            sub_category: e.sub_category,
            relocation_date: e.relocation_date,
            airline_id: e.airline_id,
            flight_number: e.flight_number,
            departure_time: e.departure_time,
            arrival_time: e.arrival_time,
            airlines_rate: e.airlines_rate,
            baggage_type: e.baggage_type,
            origin_port: e.origin_port,
            destination_port: e.destination_port,
            rate: e.rate,
            train_name_number: e.train_name_number,
        }));

        setRelocation_date1(e.relocation_date1);
        getDeliveryType(e.mode_of_transport);

        try {
            const originCityCodeResponse = await getStationCode(
                e.origin_city,
                e.mode_of_transport
            );
            setOriginCityCodeResponse(originCityCodeResponse);

            const destinationCityCodeResponse = await getStationCode(
                e.destination_city,
                e.mode_of_transport
            );
            setDestinationCityCodeResponse(destinationCityCodeResponse);
        } catch (error) {
            // Handle errors from asynchronous calls
            console.error("Error in setRelocationData:", error);
        }
    }

    function setLUD(e) {
        setFirstItem((prevItem) => ({
            ...prevItem,

            nextfollowupdatetime: "",
            openleadstage: e.openleadstage,
            closedleadstage: e.closedleadstage,
            convertedstatus: e.convertedstatus,
            remark: e.remark,
            sub_category: e.sub_category,
        }));

        if (
            e.openleadstage !== null &&
            e.openleadstage !== "0" &&
            e.openleadstage !== 0
        ) {
            getLeadSubStage(e.openleadstage);
        } else {
            getLeadSubStage(e.closedleadstage);
        }
    }

    const checkRequired = () => {
        const skipMandatoryCheckForClosedLeadStage = [42, 45, 46];
        const skipMandatoryCheckForSubCategory = [6, 19, 24, 35];
        const skipMandatoryCheckForClosedLeadStage_1 = ["42", "45", "46"];
        const skipMandatoryCheckForSubCategory_1 = ["6", "19", "24", "35"];

        const skipMandatoryCheckForNextFallowup = [41, 42, 43, 44, 45, 46, 47];
        const skipMandatoryCheckForNextFallowup_1 = [
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
        ];

        // Skip mandatory check if closed lead stage or sub category matches
        if (
            !skipMandatoryCheckForClosedLeadStage.includes(
                firstItem.closedleadstage
            ) &&
            !skipMandatoryCheckForSubCategory.includes(firstItem.sub_category) &&
            !skipMandatoryCheckForClosedLeadStage_1.includes(
                firstItem.closedleadstage
            ) &&
            !skipMandatoryCheckForSubCategory_1.includes(firstItem.sub_category)
        ) {
            const requiredFields = [
                "first_name",
                "service_type",
                "relocation_purpose",
                "where_did_you_find_us",
                "origin_country",
                "origin_state",
                "destination_country",
                "destination_state",
                "sub_category",
                "origin_city",
                "destination_city",
            ];

            // Check if any required field is empty
            for (const field of requiredFields) {
                const value = firstItem[field];
                if (
                    value === null ||
                    value === 0 ||
                    (typeof value === "string" &&
                        (value.trim() === "" || value.trim() === "0"))
                ) {
                    alert(`Please provide ${field.replace("_", " ")}!!`);
                    return false;
                }
            }
            if (
                !skipMandatoryCheckForNextFallowup.includes(
                    firstItem.closedleadstage
                ) &&
                !skipMandatoryCheckForNextFallowup_1.includes(firstItem.closedleadstage)
            ) {
                const nextFollowupDate = firstItem.nextfollowupdatetime;
                // if (!nextFollowupDate) {
                //     alert(`Please provide next follow-up date!!`);
                //     return false;
                // }
            }
            // Check if the lead is converted and sub category is converted
            if (
                (firstItem.closedleadstage === 47 && firstItem.sub_category === 55) ||
                (firstItem.closedleadstage === "47" && firstItem.sub_category === "55")
            ) {
                const Quotation = leadDetailResponse?.secpaymentDetail?.[0]?.Quotation || null;
                if (
                    !Quotation || Quotation.trim() === ""
                ) {
                    alert(`Please provide Quotation Amount(INR) !!`);
                    return false;
                }
                const fields = [
                    "email",
                    "mobile_no",
                    "relocation_date",
                    "job_type",
                    "origin_pin",
                    "destination_pin",
                    "Amount_In_AED",
                    "Token_Payment",
                    "Payment_Mode",
                    "Estimate_Id",
                    "GST",
                    "amount_exc_gst",
                ];
                for (const field of fields) {
                    const value = firstItem[field];
                    if (
                        value === null ||
                        value === 0 ||
                        (typeof value === "string" &&
                            (value.trim() === ""))
                    ) {
                        alert(`Please provide ${field.replace("_", " ")}!!`);
                        return false;
                    }
                }

                const fields1 = ["mode_of_transport", "delivery_type"];
                const modeOfTransportValue = firstItem["mode_of_transport"];
                for (const field of fields1) {
                    const value = firstItem[field];

                    if (field === "delivery_type" && modeOfTransportValue !== 1 && modeOfTransportValue !== 2) {
                        continue;
                    }

                    if (
                        value === null ||
                        value === 0 ||
                        (typeof value === "string" && (value.trim() === "" || value.trim() === "0"))
                    ) {
                        alert(`Please provide ${field.replace("_", " ")}!!`);
                        return false;
                    }
                }

                for (const [i, p] of pets.entries()) {
                    const missing = [];
                    if (!p.pet_name) missing.push("Pet Name");
                    if (!p.pet_type) missing.push("Pet Type");
                    if (!p.pet_breed) missing.push("Breed");
                    // add what you need: weight, crate_size, etc.

                    if (missing.length) {
                        alert(`Pet #${i + 1}: Please provide ${missing.join(", ")}`);
                        return false;
                    }
                }


            }
        }
        return true;
    };


    const handleNextStep = (event) => {
        event.preventDefault();

        const validation = validateFormByServiceType(firstItem, firstItem.service_type);

        if (!validation.isValid) {
            alert('Please fill in all required fields:\n' + validation.errors.join('\n'));
            return;
        }



        const searchParams = new URLSearchParams(location.search);
        const encryptedRelocationID = searchParams.get("Relocation_ID");
        navigate("/RateCalculatorindia", { state: { relocation_id: encryptedRelocationID }, });
    };

    const handleClick = (e) => {
        e.preventDefault();
        handleSubmit();
    };


    const handleSubmit = async () => {
        if (!checkRequired()) {
            return;
        }

        const payload = {
            ...firstItem,
            petsDetail: pets.map(p => ({
                ...p,
                // keep pet_age recomputed if DOB present
                pet_age: p.pet_dob ? calculateAge(p.pet_dob) : p.pet_age,
            })),
            number_of_pets: pets.length,
        };




        try {
            const storedToken = JSON.parse(localStorage.getItem("token"));
            // Make a POST request to your API endpoint

            const response = await axios.post(
                `${baseAPI}userpost/UpdateLeadDetail`,
                payload, // Send firstItem as the request body
                {
                    headers: {
                        Authorization: `Bearer ${storedToken}`,
                    },
                }
            );
            if (
                firstItem.closedleadstage === 47 ||
                firstItem.closedleadstage === "47"
            ) {
                handlePaymentDetail();
            }

            window.location.reload();
        } catch (error) {
            console.error("Error posting data:", error);
        }
    };

    const ChangeLeadOwner = async (e) => {
        e.preventDefault();
        try {
            const storedToken = JSON.parse(localStorage.getItem("token"));
            // Make a POST request to your API endpoint

            const response = await axios.post(
                `${baseAPI}userpost/UpdateLeadOwner`,
                firstItem, // Send firstItem as the request body
                {
                    headers: {
                        Authorization: `Bearer ${storedToken}`,
                    },
                }
            );
            window.location.reload();
        } catch (error) {
            // Handle errors (e.g., show an error message)
            console.error("Error posting data:", error);
        }
    };

    const openModal = (md) => {
        setSelectedMailDetail(md);
        setIsModalOpen(true);
    };

    const closeModal = () => setIsModalOpen(false);

    // --------------------add data section ends here-------------------

    // -------------------------------For saving File-----------------------------------------

    const uploadFile = async (file, fieldName) => {
        const reader = new FileReader();

        reader.onload = async () => {
            const byteImg = reader.result;
            const mediaData = {
                type: "image",
                url: byteImg,
            };

            const storedToken = JSON.parse(localStorage.getItem("token"));

            try {
                const response = await axios.post(
                    `${baseAPI}UserPost/UploadImage`,
                    mediaData,
                    {
                        headers: {
                            Authorization: `Bearer ${storedToken}`,
                        },
                    }
                );

                if (response && response.data) {
                    setFirstItem((prevFirstItem) => ({
                        ...prevFirstItem,
                        [fieldName]: response.data.data,
                    }));
                }
            } catch (error) {
                console.error("Error posting data:", error);
            }
        };

        reader.readAsDataURL(file);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const fieldName = e.target.name;

        console.log(`Uploading file: ${file.name} for field: ${fieldName}`);

        uploadFile(file, fieldName);
    };

    // -----------------------------------start for Pet Type-------------------------------------------------------------------

    const handleSelectChangeOriginCountry = (event) => {
        // Handle the select input change and update the selected value
        firstItem.origin_country = event.target.value;
        getState(event.target.value, 1);
    };

    const handleSelectChangeDestinationCountry = (event) => {
        // Handle the select input change and update the selected value
        firstItem.destination_country = event.target.value;
        getState(event.target.value, 2);
    };

    const handleSelectChangeDestinationState = (event) => {
        // Handle the select input change and update the selected value
        firstItem.destination_state = event.target.value;
        getCity(event.target.value, 2);
    };

    const handleSelectChangeOriginState = (event) => {
        // Handle the select input change and update the selected value
        firstItem.origin_state = event.target.value;
        getCity(event.target.value, 1);
    };

    const handleSelectChangePetType = (event) => {
        // Handle the select input change and update the selected value
        firstItem.pet_type = event.target.value;
        getPetBreed(event.target.value);
        //setSelectedValue(event.target.value);
    };

    // -----------------------------------End for Pet Type-------------------------------------------------------------------

    // -----------------------------------End of Add Lead-------------------------------------------------------------------

    const toggleEditMode = () => {
        setIsEditMode(!isEditMode);

        const selectedJobTypesArray = leadDetailResponse.job_type
            ? leadDetailResponse.job_type
                .split(", ")
                .map((name) => jobTypeOptions.find((option) => option.name === name))
                .filter(Boolean)
            : [];
        setSelectedJobTypes(selectedJobTypesArray);
    };

    function getStationCode(cityName, modeOfTransport) {
        if (cityName && modeOfTransport) {
            const storedToken = JSON.parse(localStorage.getItem("token"));
            return axios
                .get(
                    `${baseAPI}userget/GetStationCode?mode=${modeOfTransport}&station=${cityName}`,
                    {
                        headers: {
                            Authorization: "Bearer " + storedToken,
                        },
                    }
                )
                .then((response) => {
                    return response.data.data;
                })
                .catch((error) => {
                    console.error("Error fetching station code:", error);
                    throw error; // Re-throw the error if needed
                });
        }
    }

    const handleTransportationDataChange = async (event) => {
        const { value } = event.target;

        // Update the state with the selected mode of transport
        setFirstItem((prevItem) => {
            const updatedItem = {
                ...prevItem,
                mode_of_transport: value,
            };

            // Call handleCity with updated values
            handleCity(updatedItem);
            return updatedItem;
        });

        // Call additional methods if necessary
        getDeliveryType(value);
    };

    const handleCity = async (updatedItem) => {
        const { mode_of_transport, origin_city, destination_city } = updatedItem;

        if (mode_of_transport === "2" || mode_of_transport === "1") {
            try {
                // Call getStationCode for origin_city and destination_city
                const originCityCodeResponse = await getStationCode(
                    origin_city,
                    mode_of_transport
                );
                setOriginCityCodeResponse(originCityCodeResponse);

                const destinationCityCodeResponse = await getStationCode(
                    destination_city,
                    mode_of_transport
                );
                setDestinationCityCodeResponse(destinationCityCodeResponse);
            } catch (error) {
                // Handle any errors
                console.error("Error in handleCity:", error);
            }
        }
    };

    const handlePopUp = () => {
        let date = relocation_date1;
        if (firstItem.mode_of_transport.toString() === "1") {
            return axios
                .get(
                    `https://flight-info-api.p.rapidapi.com/schedules?version=v2&CodeType=IATA&ArrivalAirport=${firstItem.destination_city_code}&DepartureAirport=${firstItem.origin_city_code}&DepartureDateTime=` +
                    date,
                    {
                        headers: {
                            "X-RapidAPI-Key":
                                "d868e87d6emshd165c2992b3a253p1e7fe6jsn7efc154d8ee8",
                            "X-RapidAPI-Host": "flight-info-api.p.rapidapi.com",
                        },
                    }
                )
                .then((response) => {
                    setAirlinePopupData(response.data.data);
                })
                .catch((error) => {
                    console.error("Error fetching user detail:", error);
                    throw error;
                });
        } else if (firstItem.mode_of_transport.toString() === "2") {
            return axios
                .get(
                    `https://irctc1.p.rapidapi.com/api/v3/trainBetweenStations?fromStationCode=${firstItem.origin_city_code}&toStationCode=${firstItem.destination_city_code}&dateOfJourney=` +
                    date,
                    {
                        headers: {
                            "X-RapidAPI-Key":
                                "d868e87d6emshd165c2992b3a253p1e7fe6jsn7efc154d8ee8",
                            "X-RapidAPI-Host": "irctc1.p.rapidapi.com",
                        },
                    }
                )
                .then((response) => {
                    setTrainPopupData(response.data.data);
                })
                .catch((error) => {
                    console.error("Error fetching user detail:", error);
                    throw error;
                });
        } else {
        }
    };



    const goToLeadList = () => {
        // Redirect to another page
        navigate("/LeadList");
    };

    const gradientColors = ["#F15843", "#A3519F", "#5B489D"];

    const jobTypeOptions = [
        { id: "Microchip", name: "Microchip" },
        { id: "Titer test EU", name: "Titer test EU" },
        { id: "Titre test Indian", name: "Titre test Indian" },
        { id: "Export Cargo", name: "Export Cargo" },
        { id: "Import Cargo", name: "Import Cargo" },
        { id: "Export Noc", name: "Export Noc" },
        { id: "Import Noc", name: "Import Noc" },
        { id: "Cage", name: "Cage" },
        { id: "Domestic Air", name: "Domestic Air" },
        { id: "Domestic Train", name: "Domestic Train" },
        { id: "Domestic Road", name: "Domestic Road" },
        { id: "Pet Essential", name: "Pet Essential" },
        { id: "CDC PERMIT", name: "CDC PERMIT" },
    ];

    const [selectedJobTypes, setSelectedJobTypes] = useState([]);

    const onSelect = (selectedList, selectedItem) => {
        setSelectedJobTypes(selectedList);
        const selectedTypes = selectedList.map((item) => item.name).join(", ");
        setFirstItem((prevState) => ({
            ...prevState,
            job_type: selectedTypes,
        }));
    };
    const onRemove = (selectedList, removedItem) => {
        setSelectedJobTypes(selectedList);
        const selectedTypes = selectedList.map((item) => item.name).join(", ");
        setFirstItem((prevState) => ({
            ...prevState,
            job_type: selectedTypes,
        }));
    };

    const openWhatsApp = () => {
        window.open("https://web.whatsapp.com/", "_blank"); // Opens WhatsApp Web in a new tab
    };

    async function deleteDoc(client_doc_id) {
        const isConfirmed = window.confirm(
            "Are you sure you want to delete this document?"
        );
        const searchParams = new URLSearchParams(location.search);
        const encryptedRelocationID = searchParams.get("Relocation_ID");
        const Relocation_ID = decryptRelocationID(encryptedRelocationID);
        if (isConfirmed) {
            const storedToken = JSON.parse(localStorage.getItem("token"));
            // Make a POST request to your API endpoint
            const response = await axios.delete(
                `${baseAPI}userpost/DeleteClientDocs`,
                {
                    data: { client_doc_id: client_doc_id }, // Send request body
                    headers: {
                        Authorization: `Bearer ${storedToken}`,
                    },
                }
            );
            getDocument(Relocation_ID);
        }
    }

    const handlePaymentDetail = async () => {
        try {
            const storedToken = JSON.parse(localStorage.getItem("token"));
            // Make a POST request to your API endpoint

            const response = await axios.post(
                `${baseAPI}userpost/UpdatePaymentDetail`,
                paymentDetail,
                {
                    headers: {
                        Authorization: `Bearer ${storedToken}`,
                    },
                }
            );
        } catch (error) {
            // Handle errors (e.g., show an error message)
            console.error("Error posting data:", error);
        }
    };

    const goToExpenseList = () => {
        navigate('/ExpenseList', { state: { expensetype: 'ExpenseForLeadID' } });
    };

    const [showEmailModalPayLink, setShowEmailModalPayLink] = useState(false);
    const openModalLink = () => {
        setShowEmailModalPayLink(true); // ensure it unmounts
    };

    const checkRequiredForPaymentLink = () => {

        // Base mandatory fields
        let requiredFields = [
            "first_name",
            "service_type",
            "relocation_purpose",
            "where_did_you_find_us",
            "origin_country",
            "origin_state",
            "destination_country",
            "destination_state",
            "pet_type",
            "pet_breed",
            "sub_category",
            "origin_city",
            "destination_city",
            "email",
            "mobile_no",
            "relocation_date",
            "job_type",
            "origin_pin",
            "destination_pin",
            "Amount_In_AED",
            "Token_Payment",
            "Payment_Mode",
            "Estimate_Id",
            "GST",
            "amount_exc_gst",
            "mode_of_transport",
            "delivery_type",
        ];
        const Quotation = leadDetailResponse?.secpaymentDetail?.[0]?.Quotation || null;
        if (!Quotation || Quotation.trim() === "") {
            // alert(`Please provide Quotation Amount(INR) !!`);
            return false;
        }

        for (const field of requiredFields) {
            // Skip delivery_type check if mode_of_transport is not 1 or 2
            if (field === "delivery_type" && firstItem.mode_of_transport !== 1 && firstItem.mode_of_transport !== 2) {
                continue;
            }

            const value = firstItem[field];
            if (
                value === null ||
                value === 0 ||
                (typeof value === "string" && (value.trim() === "" || value.trim() === "0"))
            ) {
                // alert(`Please provide ${field.replace(/_/g, " ")}!!`);
                return false;
            }
        }
        return true;
    };

    const checkRequiredForGoToNextStep = () => {

        // Base mandatory fields
        let requiredFields = [
            "first_name",
            "service_type",
            "relocation_purpose",
            "where_did_you_find_us",
            "origin_country",
            "origin_state",
            "destination_country",
            "destination_state",
            "pet_type",
            "pet_breed",
            "sub_category",
            "origin_city",
            "destination_city",
            "email",
            "mobile_no",
            "relocation_date",
            "job_type",
            "origin_pin",
            "destination_pin",
            "mode_of_transport",
            "delivery_type",
        ];


        for (const field of requiredFields) {
            // Skip delivery_type check if mode_of_transport is not 1 or 2
            if (field === "delivery_type" && firstItem.mode_of_transport !== 1 && firstItem.mode_of_transport !== 2) {
                continue;
            }

            const value = firstItem[field];
            if (
                value === null ||
                value === 0 ||
                (typeof value === "string" && (value.trim() === "" || value.trim() === "0"))
            ) {
                // alert(`Please provide ${field.replace(/_/g, " ")}!!`);
                return false;
            }
        }
        return true;
    };




    const crateWeightMap = {
        "17": 17,
        "35": 35,
        "48": 48,
        "66": 66,
        "89": 89,
        "147": 147,
    };

    const crateSizeOptions = {
        0: "Select an option",
        17: '(24" X 16" X 16")',
        35: '(28" X 21" X 22")',
        48: '(32" X 23" X 24")',
        66: '(36" X 25" X 27")',
        89: '(40" X 27" X 30")',
        147: '(48" X 32" X 35")',
        CR82: "CR82",
    };





    return (
        <div>
            <div className="app-container-viewLeadDetails">
                <MiniDrawer />
                <div className="container-fluid container-viewLeadDetails">
                    <div className="country-header" style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "1rem",
                    }} >
                        <div>
                            <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                                <b> View Lead Details </b> | <HomeOutlinedIcon /> &gt;
                                <a style={{ cursor: "pointer" }} onClick={goToLeadList}>
                                    Lead List{" "}
                                </a>
                                <span style={{ fontSize: "20px" }}>&gt; Lead Details</span>
                            </h1>
                        </div>
                        <div style={{ backgroundColor: "#682465" }}>
                            <h5
                                style={{
                                    color: "white",
                                    fontSize: "16px",
                                    padding: "10px",
                                }}
                            >
                                Lead Id: {leadDetailResponse.relocation_id}
                            </h5>
                        </div>
                    </div>
                    <Wrapper className="LeadDetails">
                        {/* ----------------------------------Quotation builder-------------------------------- */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            <div>
                                <b style={{ textDecoration: "underline" }}>Step 1</b>
                            </div>
                            <div style={{ marginTop: "-1rem" }}>
                                <button
                                    className="btn btn-primary"
                                    style={{
                                        width: "215px",
                                        height: "52px",
                                        border: "1px solid green",
                                        margin: "17px 8px 0px 0px",
                                        backgroundColor: "white",
                                        color: "black",
                                        fontSize: "14px",
                                    }}
                                    onClick={() => {
                                        const validation = validateFormByServiceType(firstItem, firstItem.service_type);
                                        if (!validation.isValid) {
                                            alert('Please fill in all required fields before sending payment link! :\n' + validation.errors.join('\n'));
                                            return;
                                        }
                                        openModalLink();
                                    }}
                                >
                                    SEND MAIL WITH PAYMENT LINK
                                </button>
                                <button
                                    className="btn btn-primary"
                                    style={{
                                        width: "56px",
                                        height: "52px",
                                        border: "1px solid green",
                                        margin: "17px 8px 0px 0px",
                                        backgroundColor: "white",
                                    }}
                                    onClick={openWhatsApp}
                                >
                                    <img src={whatsappIcon} alt="whatsappIcon" />
                                </button>
                                <button
                                    className="btn btn-primary btn-primary-estimate"
                                    style={{
                                        margin: "1rem 1rem 0rem 0rem",
                                        backgroundColor: estimateDetail?.[0]?.estimate_attachment ? "white" : "#f0f0f0",
                                        color: estimateDetail?.[0]?.estimate_attachment ? "#6A6A6A" : "#a0a0a0",
                                        borderColor: "#C0C6CC",
                                        whiteSpace: "nowrap",
                                        width: "auto",
                                        cursor: estimateDetail?.[0]?.estimate_attachment ? "pointer" : "not-allowed",
                                    }}
                                    disabled={!estimateDetail?.[0]?.estimate_attachment}
                                    onClick={() => {
                                        if (estimateDetail?.[0]?.estimate_attachment) {
                                            window.open(`${baseImageURL}Images/Documents/${leadDetailResponse.relocation_id}/${estimateDetail[0].estimate_attachment}`, "_blank");
                                        }
                                    }}
                                >
                                    QUOTATION - {leadDetailResponse.quotation}
                                </button>
                                <button className="btn btn-primary"
                                    onClick={goToAddExpense}
                                    style={{
                                        margin: "1rem 1rem 0rem 0rem",
                                        backgroundColor: "white",
                                        color: "#6A6A6A",
                                        borderColor: "#C0C6CC",
                                        whiteSpace: "nowrap",
                                        width: "auto",
                                    }}
                                >
                                    ADD EXPENSE
                                </button>
                                {showExpenseModal && (
                                    <div className="modal-overlay">
                                        <div className="modal-content" style={{ maxWidth: "1000px" }}>
                                            <button className="close-button leadExpenseListMswork" onClick={closeExpenseModal}>X</button>
                                            <LeadExpenseList relocationId={Relocation_ID} onClose={closeExpenseModal} />
                                        </div>
                                    </div>
                                )}


                                {canShow && (
                                    <button
                                        className={
                                            isEditMode
                                                ? "btn btn-primary edit-Button-on"
                                                : "btn btn-primary edit-Button-off"
                                        }
                                        onClick={toggleEditMode}
                                    >
                                        EDIT
                                    </button>
                                )}
                            </div>
                        </div>
                    </Wrapper>
                    {showEmailModalPayLink && (
                        <SendMailWithPdf relocation_id={Relocation_ID} email={firstItem.email} Quotation={paymentDetail.Quotation} first_name={leadDetailResponse.first_name} setShowEmailModalPayLink={setShowEmailModalPayLink} lead_owner={leadDetailResponse.assigned_to} />
                    )}
                    <br />

                    <div className="tabs" ref={tabContainerRef}>
                        {tabs.map((tab, index) => (
                            <span
                                key={tab}
                                ref={(el) => (tabRefs.current[index] = el)}
                                className={`tab ${activeTab === tab ? "active" : ""}`}
                                onClick={() => setActiveTab(tab)}
                            >
                                {tab}
                            </span>
                        ))}
                    </div>


                    <hr className="hr-mychange" />
                    <div
                        className="tab-indicator"
                        style={indicatorStyle} // Apply dynamic styles here
                    ></div>

                    {activeTab === "Lead Details" && (
                        <div>
                            {/* ------------------------lead deatil--------------------- */}
                            <Wrapper className="LeadDetails">

                                {isEditMode ? (
                                    <>
                                        {/* ----------Edit mode--------------- */}
                                        <div className="viewLeadDetails-form">
                                            <table
                                                style={{
                                                    width: "100%",
                                                    color: "#6A6A6A",
                                                    borderRadius: "5px",
                                                }}
                                            >
                                                <tr className="viewLeadDetailsHeading">
                                                    <th
                                                        colSpan={2}
                                                        style={{
                                                            background: "#5B489D",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        <span style={{ fontSize: "18px" }}>
                                                            {" "}
                                                            Customer Detail{" "}
                                                        </span>
                                                    </th>
                                                    <th
                                                        colSpan={2}
                                                        style={{
                                                            background: "#5B489D",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {" "}
                                                        <span style={{ fontSize: "18px" }}>Lead Detail </span>
                                                    </th>
                                                </tr>
                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Full Name</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="first_name"
                                                            value={firstItem.first_name}
                                                            onChange={handleChange1}
                                                            required={isFieldRequired('first_name', firstItem.service_type)}
                                                        />
                                                    </td>
                                                    <th>
                                                        <span>Lead ID</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.relocation_id}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Gender</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="gender"
                                                            value={firstItem.gender}
                                                            onChange={handleChange1}
                                                        >
                                                            <option selected value="">
                                                                Select Gender
                                                            </option>
                                                            <option value="Male">Male</option>
                                                            <option value="Female">Female</option>
                                                        </select>
                                                    </td>
                                                    <th>
                                                        <span>Lead Date</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.createddate}</span>
                                                    </td>
                                                    {/* <th>
                        <span>Last Updated Date</span>
                      </th>
                      <td>
                        <span>{leadDetailResponse.modifieddate}</span>
                      </td> */}
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Email ID</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="email"
                                                            name="email"
                                                            value={firstItem.email}
                                                            onChange={handleChange1}
                                                        />
                                                    </td>
                                                    <th>
                                                        <span>Last Updated Date</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.modifieddate}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Mobile Number</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="tel"
                                                            name="mobile_no"
                                                            value={firstItem.mobile_no}
                                                            onChange={handleChange1}
                                                        />
                                                    </td>
                                                    <th>
                                                        <span>Lead Type</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.lead_region}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Service Type</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="service_type"
                                                            value={firstItem.service_type}
                                                            onChange={handleServiceTypeChange}
                                                        >
                                                            <option value="0">Select an option</option>
                                                            {serviceTypeResponse !== null ? (
                                                                serviceTypeResponse.map((item) => (
                                                                    <option value={item.service_type}>
                                                                        {item.ServiceTypeName}
                                                                    </option>
                                                                ))
                                                            ) : (
                                                                <p>empty</p>
                                                            )}
                                                        </select>
                                                    </td>
                                                    <th>
                                                        <span>Lead Source</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.leadsource1}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Purpose of Relocation</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="relocation_purpose"
                                                            value={firstItem.relocation_purpose}
                                                            onChange={handleChange1}
                                                        >
                                                            <option value="" disabled selected>
                                                                Relocation Purpose*
                                                            </option>
                                                            <option value="Change of Residence/Shifting">
                                                                Change of Residence/Shifting
                                                            </option>
                                                            <option value="Job Change/Switch/Transfer">
                                                                Job Change/Switch/Transfer
                                                            </option>
                                                            <option value="Moving out for studies">
                                                                Moving out for studies
                                                            </option>
                                                            <option value="Receiving the pet from the family">
                                                                Receiving the pet from the family
                                                            </option>
                                                            <option value="Sale/Purchase of the pet">
                                                                Sale/Purchase of the pet
                                                            </option>
                                                            <option value="Sending the pet to the family">
                                                                Sending the pet to the family
                                                            </option>
                                                            <option value="Temporary move">Temporary move</option>
                                                            <option value="Vacation/Trip/Travelling">
                                                                Vacation/Trip/Travelling
                                                            </option>
                                                        </select>
                                                    </td>
                                                    <th>
                                                        <span>Lead Status</span>
                                                    </th>
                                                    <td>
                                                        <span
                                                            style={{
                                                                color: "white",
                                                                fontWeight: "bold",
                                                                textAlign: "center",
                                                                backgroundColor: getStatusColor(
                                                                    leadDetailResponse.status_name
                                                                ),
                                                            }}
                                                        >
                                                            {" "}
                                                            &nbsp;
                                                            {leadDetailResponse.status_name} &nbsp;
                                                        </span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Find Where</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="where_did_you_find_us"
                                                            onChange={handleChange1}
                                                            value={firstItem.where_did_you_find_us}
                                                        >
                                                            <option value="0">Select an option</option>
                                                            <option value="1">Facebook</option>
                                                            <option value="2">Instagram</option>
                                                            <option value="3">LinkedIn</option>
                                                            <option value="4">Through existing user</option>
                                                            <option value="5">Friends and Family</option>
                                                            <option value="6">While searching on google</option>
                                                        </select>
                                                    </td>
                                                    <th>
                                                        <span>Current Lead Owner</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.name}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Alternate number</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="tel"
                                                            name="alternate_number"
                                                            value={firstItem.alternate_number}
                                                            onChange={handleChange1}
                                                        />
                                                    </td>
                                                    <th>
                                                        {" "}
                                                        <span>Previous Lead Owner</span>
                                                    </th>
                                                    <td>
                                                        {leadOwnerResponse.map((item, index) => (
                                                            <span
                                                                key={index}
                                                                onMouseEnter={(e) => handleMouseEnter(item, e)}
                                                                onMouseLeave={handleMouseLeave}
                                                                style={{ marginRight: "10px", cursor: "pointer" }}
                                                                className={hoveredItem === item ? "highlight" : ""}
                                                            >
                                                                {item.name}
                                                            </span>
                                                        ))}
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Scope of Work</span>
                                                    </th>
                                                    <td>
                                                        <Multiselect
                                                            className="multiselect-change-placeholder"
                                                            options={jobTypeOptions}
                                                            selectedValues={selectedJobTypes}
                                                            onSelect={onSelect}
                                                            onRemove={onRemove}
                                                            displayValue="name"
                                                            placeholder="Select Scope of work"
                                                        />
                                                    </td>
                                                    <th><span>Ops Coordinator</span> </th>
                                                    <td><span>{leadDetailResponse.Assigned_By_Coordinator}</span></td>
                                                </tr>
                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>WhatsApp Title</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="whatsapp_title"
                                                            value={firstItem.whatsapp_title}
                                                            onChange={handleChange1}
                                                        />
                                                    </td>
                                                    <th>
                                                        <span>Lead Category</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="lead_label"
                                                            value={firstItem.lead_label}
                                                            onChange={handleChange1}
                                                        >
                                                            <option value="0">Select an option</option>
                                                            {leadLabelResponse !== null &&
                                                                leadLabelResponse !== undefined &&
                                                                leadLabelResponse.length > 0 ? (
                                                                leadLabelResponse.map((item) => (
                                                                    <option value={item.label_id}>
                                                                        {item.label_name} {"(" + item.label_color + ")"}{" "}
                                                                    </option>
                                                                ))
                                                            ) : (
                                                                <option value="-1">NA</option>
                                                            )}
                                                        </select>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>User ID</span>
                                                    </th>
                                                    <td>
                                                        <span>{firstItem.user_id}</span>
                                                    </td>
                                                    <th>
                                                        <span>Customer Type</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="customer_type"
                                                            value={firstItem.customer_type}
                                                            onChange={handleChange1}
                                                        >
                                                            <option value="0">Select an option</option>
                                                            <option value="B2C">B2C</option>
                                                            <option value="B2B">B2B</option>
                                                        </select>
                                                    </td>
                                                </tr>



                                            </table>
                                            {hoveredItem && (
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        // top: `${tooltipPosition.top}px`,
                                                        // left: `${tooltipPosition.left}px`,
                                                        marginTop: "10px",
                                                        marginLeft: "10px",
                                                        backgroundColor: "#000",
                                                        border: "1px solid #ccc",
                                                        padding: "10px",
                                                        zIndex: 1000,
                                                        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                                                        pointerEvents: "none",
                                                        opacity: "60%",
                                                        color: "white",
                                                    }}
                                                >
                                                    <div>
                                                        Assignment Detail: {hoveredItem.assignment_detail}
                                                    </div>
                                                    <div>Assigned On: {hoveredItem.assigned_on}</div>
                                                </div>
                                            )}
                                        </div>
                                        <br />
                                        {/* --------------------------Email Details---------------------------------------- */}
                                        {mailDetail.length > 0 && (
                                            <div className="viewLeadDetails-form">
                                                <table
                                                    style={{
                                                        width: "100%",
                                                        color: "#6A6A6A",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <tr className="viewLeadDetailsHeading">
                                                        <th
                                                            colSpan={4}
                                                            style={{
                                                                background: "#5B489D",
                                                                color: "white",
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            <span style={{ fontSize: "18px" }}>
                                                                {" "}
                                                                Email Detail{" "}
                                                            </span>
                                                        </th>
                                                    </tr>
                                                </table>
                                                <div style={{ maxHeight: "200px", overflowY: "scroll" }}>
                                                    <table
                                                        style={{
                                                            width: "100%",
                                                            color: "#6A6A6A",
                                                            borderRadius: "5px",
                                                        }}
                                                    >
                                                        <thead
                                                            className="viewLeadDetailsHeading"
                                                            style={{
                                                                position: "sticky",
                                                                top: "0",
                                                                zIndex: "1",
                                                                background: "#5B489D",
                                                                fontWeight: "bold",
                                                                fontSize: "16px",
                                                            }}
                                                        >
                                                            <tr>
                                                                <th
                                                                    style={{
                                                                        width: "41%",
                                                                        padding: " 0 10px 0 13px",
                                                                    }}
                                                                >
                                                                    Subject
                                                                </th>
                                                                <th style={{ width: "10%", fontSize: "14px" }}>
                                                                    Date & Time
                                                                </th>
                                                                <th>Sent or Receive By</th>
                                                                <th>Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {mailDetail.map((md, index) => (
                                                                <tr key={index} onClick={() => openModal(md)}>
                                                                    <td
                                                                        style={{
                                                                            width: "41%",
                                                                            padding: " 0 10px 0 13px",
                                                                        }}
                                                                    >
                                                                        <img
                                                                            style={{ height: "32px", width: "32px" }}
                                                                            src={mailIcon}
                                                                            alt="no img"
                                                                        />{" "}
                                                                        <span style={{ fontSize: "13px" }}>
                                                                            {md.subject}
                                                                        </span>
                                                                        <br />
                                                                        <span
                                                                            style={{
                                                                                fontSize: "13px",
                                                                                paddingLeft: "38px",
                                                                                width: "12%",
                                                                            }}
                                                                        >
                                                                            {md.fromAddress}
                                                                        </span>
                                                                    </td>
                                                                    <td style={{ width: "10%", fontSize: "14px" }}>
                                                                        {md.created_date}
                                                                    </td>
                                                                    <td style={{ fontSize: "13px" }}>{md.sender}</td>
                                                                    <td>Sent</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {isModalOpen && (
                                                    <div
                                                        style={{
                                                            position: "fixed",
                                                            top: "50%",
                                                            left: "52%",
                                                            transform: "translate(-50%, -50%)",
                                                            zIndex: 1000,
                                                            backgroundColor: "#F4F4F4",
                                                            padding: "20px",
                                                            borderRadius: "8px",
                                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                                            width: "90%",
                                                            fontSize: "20px",
                                                            marginTop: "2rem",
                                                            marginBottom: "3rem",
                                                        }}
                                                    >
                                                        <div
                                                            onClick={closeModal}
                                                            style={{
                                                                position: "absolute",
                                                                top: "16px",
                                                                right: "10px",
                                                                background: "none",
                                                                border: "none",
                                                                fontSize: "16px",
                                                                cursor: "pointer",
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            X
                                                        </div>
                                                        {/* Your modal content here */}

                                                        <div style={{ paddingBottom: "2rem" }}>
                                                            <p>{selectedMailDetail.subject}</p>
                                                            <hr />

                                                            <div
                                                                style={{ display: "flex", flexDirection: "column" }}
                                                            >
                                                                <div style={{ display: "flex" }}>
                                                                    <span
                                                                        style={{ fontWeight: "bold", fontSize: "16px" }}
                                                                    >
                                                                        From:
                                                                    </span>
                                                                    <span style={{ padding: "2px 19px 11px 11px" }}>
                                                                        {selectedMailDetail.sender}
                                                                    </span>
                                                                    <span style={{ padding: "2px 19px 11px 50px" }}>
                                                                        {selectedMailDetail.fromAddress}
                                                                    </span>
                                                                </div>

                                                                <div style={{ display: "flex" }}>
                                                                    <span
                                                                        style={{ fontWeight: "bold", fontSize: "16px" }}
                                                                    >
                                                                        To:
                                                                    </span>
                                                                    <span style={{ padding: "2px 19px 11px 25px" }}>
                                                                        {selectedMailDetail.toAddress}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <hr />

                                                            <div
                                                                style={{
                                                                    maxHeight: "300px",
                                                                    paddingTop: "1rem",
                                                                    fontSize: "16px",
                                                                    overflowY: "auto",
                                                                }}
                                                            >
                                                                {/*--------------Add your email body here*/}
                                                                <p>{selectedMailDetail.summary}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        <br />
                                        {/* ---------------------------IVR Details- edit--------------------------------------------------------- */}
                                        <div className="viewLeadDetails-form">
                                            {ivrDetail.map((ivr, index) => (
                                                <table
                                                    style={{
                                                        width: "100%",
                                                        color: "#6A6A6A",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <tr className="viewLeadDetailsHeading">
                                                        <th
                                                            colSpan={4}
                                                            style={{
                                                                background: "#5B489D",
                                                                color: "white",
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            <span style={{ fontSize: "18px" }}> IVR Detail </span>
                                                        </th>
                                                    </tr>

                                                    <tr className="viewLeadDetailsHeading">
                                                        <th>
                                                            <span>Call ID</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.call_id}</span>
                                                        </td>
                                                        <th>
                                                            <span>Customer number</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.client_number}</span>
                                                        </td>
                                                    </tr>

                                                    <tr
                                                        style={{ width: "100%" }}
                                                        className="viewLeadDetailsHeading"
                                                    >
                                                        <th>
                                                            <span>Call Direction</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.direction}</span>
                                                        </td>
                                                        <th>
                                                            <span>Associate Name</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.agent_name}</span>
                                                        </td>
                                                    </tr>

                                                    <tr
                                                        style={{ width: "100%" }}
                                                        className="viewLeadDetailsHeading"
                                                    >
                                                        <th>
                                                            <span>Call Status</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.status}</span>
                                                        </td>
                                                        <th>
                                                            <span>Associate Number</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.agent_number}</span>
                                                        </td>
                                                    </tr>

                                                    <tr
                                                        style={{ width: "100%" }}
                                                        className="viewLeadDetailsHeading"
                                                    >
                                                        <th>
                                                            <span>Call Duration</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.call_duration}</span>
                                                        </td>
                                                        <th>
                                                            <span>Did Number</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.did_number}</span>
                                                        </td>
                                                    </tr>

                                                    <tr
                                                        style={{ width: "100%" }}
                                                        className="viewLeadDetailsHeading"
                                                    >
                                                        <th>
                                                            <span>Call Answered Seconds</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.answered_seconds}</span>
                                                        </td>
                                                        <th>
                                                            <span>Description</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.description}</span>
                                                        </td>
                                                    </tr>

                                                    <tr className="viewLeadDetailsHeading">
                                                        <th>
                                                            <span>Call End Time</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.end_stamp}</span>
                                                        </td>
                                                        <th>
                                                            <span>Department Name </span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.department_name}</span>
                                                        </td>
                                                    </tr>

                                                    <tr className="viewLeadDetailsHeading">
                                                        <th>
                                                            <span>Call Date</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.call_date}</span>
                                                        </td>
                                                        <th>
                                                            <span>Call Time</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.call_time}</span>
                                                        </td>
                                                    </tr>
                                                    {canShow && (
                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>Recording URL</span>
                                                            </th>
                                                            <td colSpan={3}>
                                                                <span>
                                                                    {" "}
                                                                    <a
                                                                        href={ivr.description_url}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        {ivr.description_url}
                                                                    </a>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </table>
                                            ))}
                                        </div>
                                        <br />
                                        <br />
                                        {/* --------------------------Relocation Details---------------------------------------- */}
                                        <div className="viewLeadDetails-form">
                                            <table
                                                style={{
                                                    width: "100%",
                                                    color: "#6A6A6A",
                                                    borderRadius: "5px",
                                                }}
                                            >
                                                <tr className="viewLeadDetailsHeading">
                                                    <th
                                                        colSpan={4}
                                                        style={{
                                                            background: "#5B489D",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        <span style={{ fontSize: "18px" }}>
                                                            {" "}
                                                            Relocation Detail{" "}
                                                        </span>
                                                    </th>
                                                </tr>
                                                <tr
                                                    className="viewLeadDetailsHeading"
                                                    style={{ height: "3px" }}
                                                >
                                                    <td
                                                        colSpan={4}
                                                        style={{
                                                            background: "#ffffff",
                                                        }}
                                                    ></td>
                                                </tr>
                                                <tr className="viewLeadDetailsHeading">
                                                    <th
                                                        colSpan={2}
                                                        style={{
                                                            background: "#A3519F",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <span style={{ fontSize: "16px" }}> From </span>
                                                    </th>

                                                    <th
                                                        colSpan={2}
                                                        style={{
                                                            background: "#A3519F",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <span style={{ fontSize: "16px" }}> To </span>
                                                    </th>
                                                </tr>
                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>From Country</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="ddlorigin_country"
                                                            onChange={handleSelectChangeOriginCountry}
                                                            value={firstItem.origin_country}
                                                        >
                                                            <option value="0">Select an option</option>
                                                            {originCountryResponse.map((item) => (
                                                                <option value={item.id}>{item.name}</option>
                                                            ))}
                                                        </select>
                                                    </td>

                                                    <th>
                                                        <span>To Country</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="ddldestination_country"
                                                            onChange={handleSelectChangeDestinationCountry}
                                                            value={firstItem.destination_country}
                                                        >
                                                            <option value="0" style={{ width: "5rem" }}>
                                                                Select an option
                                                            </option>
                                                            {destinationCountryResponse.map((item) => (
                                                                <option value={item.id}>{item.name}</option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>From State</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="ddlorigin_state"
                                                            placeholder={leadDetailResponse.origin_state1}
                                                            onChange={handleSelectChangeOriginState}
                                                            value={firstItem.origin_state}
                                                        >
                                                            <option value="0">Select an option</option>
                                                            {originStateResponse.map((item) => (
                                                                <option value={item.state_id}>
                                                                    {item.stateName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                    <th>
                                                        <span>To State</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="ddldestination_state"
                                                            onChange={handleSelectChangeDestinationState}
                                                            value={firstItem.destination_state}
                                                        >
                                                            <option value="0">Select an option</option>
                                                            {destinationStateResponse.map((item) => (
                                                                <option value={item.state_id}>
                                                                    {item.stateName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>From City</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="origin_city"
                                                            value={firstItem.origin_city}
                                                            onChange={handleChange2}
                                                        >
                                                            <option value="">Please select</option>
                                                            {originCityResponse.map((item) => (
                                                                <option value={item.id}>{item.name}</option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                    <th>
                                                        <span>To City</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="destination_city"
                                                            value={firstItem.destination_city}
                                                            onChange={handleChange2}
                                                        >
                                                            <option value="0">Select an option</option>
                                                            {destinationCityResponse.map((item) => (
                                                                <option value={item.id}>{item.name}</option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Pickup Address</span>
                                                    </th>
                                                    <td>
                                                        <GooglePlacesAutocomplete
                                                            apiKey="AIzaSyCnMYMLMc3htmyV4XIuqot7lUJIVexFS6w"
                                                            className="form-control"
                                                            placeholder="Please Enter*"
                                                            onPlaceSelected={(place) =>
                                                                handleSelect(place, "origin_address")
                                                            }
                                                            value={firstItem.origin_address} // Controlled input value
                                                            onChange={(e) => handleChange4(e, "origin_address")} // Allow typing in the input
                                                        />
                                                    </td>
                                                    <th>
                                                        <span>Drop Address</span>
                                                    </th>
                                                    <td>
                                                        <GooglePlacesAutocomplete
                                                            apiKey="AIzaSyCnMYMLMc3htmyV4XIuqot7lUJIVexFS6w"
                                                            className="form-control"
                                                            placeholder="Please Enter*"
                                                            onPlaceSelected={(place) =>
                                                                handleSelect(place, "destination_address")
                                                            }
                                                            value={firstItem.destination_address} // Controlled input value
                                                            onChange={(e) =>
                                                                handleChange4(e, "destination_address")
                                                            } // Allow typing in the input
                                                        />
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Origin Pin</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="origin_pin"
                                                            value={firstItem.origin_pin}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange1}
                                                        />
                                                    </td>
                                                    <th>
                                                        <span>Destination Pin</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="destination_pin"
                                                            value={firstItem.destination_pin}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Origin Port</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="origin_port"
                                                            value={firstItem.origin_port}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange1}
                                                        />
                                                    </td>
                                                    <th>
                                                        <span>Destination Port</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="destination_port"
                                                            value={firstItem.destination_port}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange}
                                                        />
                                                    </td>
                                                </tr>





                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Sender Name</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="origin_contact_person"
                                                            value={firstItem.origin_contact_person}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange}
                                                        />
                                                    </td>

                                                    <th>
                                                        <span>Receiver Name</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="destination_contact_person"
                                                            value={firstItem.destination_contact_person}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange}
                                                        />
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Sender Contact</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="origin_contact_no"
                                                            value={firstItem.origin_contact_no}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange}
                                                        />
                                                    </td>
                                                    <th>
                                                        <span>Receiver Contact</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="destination_contact_no"
                                                            value={firstItem.destination_contact_no}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange}
                                                        />
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Relocation Date</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="date"
                                                            name="relocation_date"
                                                            value={firstItem.relocation_date}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange1}
                                                        />
                                                    </td>
                                                    <th>
                                                        <span>Lead Type</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.lead_region}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Available Slots</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="datetime-local"
                                                            name="available_slot"
                                                            value={firstItem.available_slot}
                                                            onChange={handleChange1}
                                                        />
                                                    </td>
                                                    <th>
                                                        <span>Mode Of Transportation</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="mode_of_transport"
                                                            value={firstItem.mode_of_transport}
                                                            onChange={handleTransportationDataChange}
                                                        >
                                                            <option value="0">Please select</option>
                                                            <option value="1">Air </option>
                                                            <option value="2">Train </option>
                                                            <option value="3">Road </option>
                                                            <option value="4">NA</option>
                                                        </select>
                                                    </td>
                                                </tr>

                                                {firstItem.mode_of_transport.toString() === "2" ? (
                                                    <>
                                                        {/* ---Train-- Edit Mode*/}

                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>Delivery Type</span>
                                                            </th>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    name="delivery_type"
                                                                    onChange={handleChange}
                                                                    value={firstItem.delivery_type}
                                                                >
                                                                    <option value="0">Select an option</option>
                                                                    {deliveryTypeResponse.map((item) => (
                                                                        <option value={item.delivery_type_id}>
                                                                            {item.delivery_type_name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </td>
                                                            <th>
                                                                <span>Price</span>
                                                            </th>
                                                            <td>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="price"
                                                                    value={firstItem.price}
                                                                    placeholder="Please Enter*"
                                                                    onChange={handleChange}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>From City Code</span>
                                                            </th>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    name="origin_city_code"
                                                                    value={firstItem.origin_city_code}
                                                                    onChange={handleChange3}
                                                                >
                                                                    <option value="0">Select an option</option>
                                                                    {originCityCodeResponse !== null &&
                                                                        originCityCodeResponse !== undefined &&
                                                                        originCityCodeResponse.length > 0 ? (
                                                                        originCityCodeResponse.map((item) => (
                                                                            <option value={item.code}>
                                                                                {item.name} {"(" + item.code + ")"}{" "}
                                                                            </option>
                                                                        ))
                                                                    ) : (
                                                                        <option value="-1">NA</option>
                                                                    )}
                                                                </select>
                                                            </td>
                                                            <th>
                                                                <span>To City Code</span>
                                                            </th>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    name="destination_city_code"
                                                                    value={firstItem.destination_city_code}
                                                                    onChange={handleChange3} // Ensure this function updates state properly
                                                                >
                                                                    <option value="0">Select an option</option>
                                                                    {destinationCityCodeResponse !== null &&
                                                                        destinationCityCodeResponse !== undefined &&
                                                                        destinationCityCodeResponse.length > 0 ? (
                                                                        destinationCityCodeResponse.map((item) => (
                                                                            <option key={item.code} value={item.code}>
                                                                                {" "}
                                                                                {/* Added unique key */}
                                                                                {item.name} {"(" + item.code + ")"}
                                                                            </option>
                                                                        ))
                                                                    ) : (
                                                                        <option value="-1">NA</option>
                                                                    )}
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>Shipment Reference Number</span>
                                                            </th>
                                                            <td>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="awb_number"
                                                                    value={firstItem.awb_number}
                                                                    placeholder="Please Enter*"
                                                                    onChange={handleChange}
                                                                />


                                                            </td>
                                                            <th>
                                                                <span>Train Name And Number</span>
                                                            </th>
                                                            <td>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="train_name_number"
                                                                    value={firstItem.train_name_number}
                                                                    placeholder="Please Enter*"
                                                                    onChange={handleChange}
                                                                />


                                                            </td>
                                                        </tr>
                                                    </>
                                                ) : (
                                                    <></>
                                                )}

                                                {firstItem.mode_of_transport.toString() === "1" ? (
                                                    <>
                                                        {/* Air in edit mode */}
                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>Delivery Type</span>
                                                            </th>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    name="delivery_type"
                                                                    onChange={handleChange}
                                                                    value={firstItem.delivery_type}
                                                                >
                                                                    <option value="0">Select an option</option>
                                                                    {deliveryTypeResponse.map((item) => (
                                                                        <option value={item.delivery_type_id}>
                                                                            {item.delivery_type_name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </td>
                                                            <th>
                                                                <span>Baggage Type</span>
                                                            </th>
                                                            <td> <select
                                                                className="form-control"
                                                                name="baggage_type"
                                                                onChange={handleChange}
                                                                value={firstItem.baggage_type}
                                                            >
                                                                <option value="0">Select an option</option>
                                                                <option value="Cabin">Cabin</option>
                                                                <option value="Cargo Hold">Cargo Hold</option>
                                                                <option value="Manifest cargo">Manifest cargo</option>
                                                            </select>
                                                            </td>
                                                        </tr>
                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>From Airport</span>
                                                            </th>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    name="origin_city_code"
                                                                    value={firstItem.origin_city_code}
                                                                    onChange={handleChange3}
                                                                >
                                                                    <option value="0">Select an option</option>
                                                                    {originCityCodeResponse !== null &&
                                                                        originCityCodeResponse !== undefined &&
                                                                        originCityCodeResponse.length > 0 ? (
                                                                        originCityCodeResponse.map((item) => (
                                                                            <option value={item.code}>
                                                                                {item.name} {"(" + item.code + ")"}{" "}
                                                                            </option>
                                                                        ))
                                                                    ) : (
                                                                        <option value="-1">NA</option>
                                                                    )}
                                                                </select>
                                                            </td>
                                                            <th>
                                                                <span>To Airport</span>
                                                            </th>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    name="destination_city_code"
                                                                    value={firstItem.destination_city_code}
                                                                    onChange={handleChange3} // Ensure this function updates state properly
                                                                >
                                                                    <option value="0">Select an option</option>
                                                                    {destinationCityCodeResponse !== null &&
                                                                        destinationCityCodeResponse !== undefined &&
                                                                        destinationCityCodeResponse.length > 0 ? (
                                                                        destinationCityCodeResponse.map((item) => (
                                                                            <option key={item.code} value={item.code}>
                                                                                {" "}
                                                                                {/* Added unique key */}
                                                                                {item.name} {"(" + item.code + ")"}
                                                                            </option>
                                                                        ))
                                                                    ) : (
                                                                        <option value="-1">NA</option>
                                                                    )}
                                                                </select>
                                                            </td>
                                                        </tr>


                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>Departure Time (Estimate)</span>
                                                            </th>
                                                            <td>
                                                                <input
                                                                    className="form-control"
                                                                    type="time"
                                                                    name="departure_time"
                                                                    value={firstItem.departure_time}
                                                                    placeholder="Please Enter*"
                                                                    onChange={handleChange}
                                                                />
                                                            </td>
                                                            <th>
                                                                <span>Arrival Time (Estimate)</span>
                                                            </th>
                                                            <td>
                                                                <input
                                                                    className="form-control"
                                                                    type="time"
                                                                    name="arrival_time"
                                                                    value={firstItem.arrival_time}
                                                                    placeholder="Please Enter*"
                                                                    onChange={handleChange}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>AWB Number</span>
                                                            </th>
                                                            <td>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="awb_number"
                                                                    value={firstItem.awb_number}
                                                                    placeholder="Please Enter*"
                                                                    onChange={handleChange}
                                                                />
                                                            </td>
                                                            <th>
                                                                <span>Request Rate for Airlines</span>
                                                            </th>
                                                            <td style={{ display: "flex" }}>
                                                                <select
                                                                    className="form-control"
                                                                    name="airlines_rate"
                                                                    value={firstItem.airlines_rate}
                                                                    onChange={handleChange3}
                                                                    style={{
                                                                        width: "180px",
                                                                        marginRight: "10px",
                                                                    }}
                                                                >
                                                                    <option value="0">Select an option</option>
                                                                    {airlineNameResponse !== null &&
                                                                        airlineNameResponse !== undefined &&
                                                                        airlineNameResponse.length > 0 ? (
                                                                        airlineNameResponse.map((item) => (
                                                                            <option value={item.airline_id}>
                                                                                {item.airline_name}
                                                                            </option>
                                                                        ))
                                                                    ) : (
                                                                        <option value="-1">NA</option>
                                                                    )}
                                                                </select>

                                                                <button
                                                                    style={{
                                                                        border: "2px solid #5B489D",
                                                                        color: "#5B489D",
                                                                        height: "44px",
                                                                        width: "115px",
                                                                    }}
                                                                >
                                                                    REQUEST
                                                                </button>

                                                            </td>
                                                        </tr>
                                                    </>
                                                ) : (
                                                    <></>
                                                )}
                                                <tr
                                                    className="viewLeadDetailsHeading"
                                                    style={{ display: "none" }}
                                                >
                                                    <th>
                                                        <span>Relocation Detail</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            style={{ width: "99%" }}
                                                            className="form-control"
                                                            type="input"
                                                            name="relocation_detail"
                                                            value={firstItem.relocation_detail}
                                                            onClick={handlePopUp}
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#myModal"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr className="viewLeadDetailsHeading" style={{ display: "none" }}>
                                                    <th>
                                                        <span>Pickup Distance</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="distance"
                                                            value={firstItem.distance}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange}
                                                        //onClick={getDistance}
                                                        />
                                                    </td>
                                                    <th>
                                                        <span>Drop Distance</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="distance2"
                                                            value={firstItem.distance2}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange}
                                                        //onClick={getDistance}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Airline Name</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="airline_id"
                                                            value={firstItem.airline_id}
                                                            onChange={handleChange3}
                                                        >
                                                            <option value="0">Select an option</option>
                                                            {airlineNameResponse !== null &&
                                                                airlineNameResponse !== undefined &&
                                                                airlineNameResponse.length > 0 ? (
                                                                airlineNameResponse.map((item) => (
                                                                    <option value={item.airline_id}>
                                                                        {item.airline_name}
                                                                    </option>
                                                                ))
                                                            ) : (
                                                                <option value="-1">NA</option>
                                                            )}
                                                        </select>
                                                    </td>
                                                    <th>
                                                        <span>Flight Number</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="flight_number"
                                                            value={firstItem.flight_number}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange}
                                                        />
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        {/* ------------------------------------------------------------------------------------------------ */}
                                        <br />
                                        <br />
                                        {/* --------------------------Pet Details---------------------------------------- */}


                                        <PetDetailsEditor
                                            pets={pets}
                                            setPets={setPets}
                                            petTypeOptions={petTypeResponse}
                                            petBreedOptionsByType={(typeId) =>
                                                (petBreedResponse || []).filter(b => String(b.PetType) === String(typeId))
                                            }
                                            onPickBreed={(typeId) => getPetBreed(typeId)}  // optional now; can remove
                                            crateSizeOptions={crateSizeOptions}
                                        />

                                        <br></br> <br></br>
                                        {/* ----------------------------Pet images Edit------------------------------------------------ */}
                                        <div className="viewLeadDetails-form">
                                            <table
                                                style={{
                                                    width: "100%",
                                                    color: "#6A6A6A",
                                                    borderRadius: "5px",
                                                }}
                                            >
                                                <tr className="viewLeadDetailsHeading">
                                                    <th
                                                        colSpan={2}
                                                        style={{
                                                            background: "#5B489D",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        <span style={{ fontSize: "18px" }}>
                                                            {" "}
                                                            Pet related Pictures{" "}
                                                        </span>
                                                    </th>
                                                </tr>
                                                <tr
                                                    className="viewLeadDetailsHeading"
                                                    style={{ height: "20px" }}
                                                >
                                                    <th
                                                        colSpan={2}
                                                        style={{
                                                            background: "#FFFFFF",
                                                        }}
                                                    ></th>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        <div
                                                            style={{
                                                                border: "1px solid #DEE2E6",
                                                                borderRadius: "1rem",
                                                            }}
                                                        >
                                                            <div className="pet-image-text-1">
                                                                <h5>Vaccination Book</h5>
                                                            </div>
                                                            <tr>
                                                                <td style={{ height: "11rem" }}>
                                                                    {firstItem.vaccinationbook_front &&
                                                                        firstItem.vaccinationbook_front.trim() !== "" ? (
                                                                        <img
                                                                            alt="Vaccination Book Front"
                                                                            src={vaccinationBookFront}
                                                                            style={{ width: "100%", height: "11rem" }}
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            alt="Not Found"
                                                                            src={images2}
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "11rem",
                                                                                opacity: "0.1",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </td>
                                                                <td style={{ height: "11rem" }}>
                                                                    {firstItem.vaccinationbook_back &&
                                                                        firstItem.vaccinationbook_back.trim() !== "" ? (
                                                                        <img
                                                                            alt="Vaccination Book Back"
                                                                            src={vaccinationBookBack}
                                                                            style={{ width: "100%", height: "11rem" }}
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            alt="Not Found"
                                                                            src={images2} // Provide the URL for the "not found" image
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "11rem",
                                                                                opacity: "0.1",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        name="VaccinationBook_Front"
                                                                        onChange={handleFileChange}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        name="VaccinationBook_Back"
                                                                        onChange={handleFileChange}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div
                                                            style={{
                                                                border: "1px solid #DEE2E6",
                                                                borderRadius: "1rem",
                                                            }}
                                                        >
                                                            <h5 className="pet-image-text-2">Pet Photos</h5>
                                                            <tr>
                                                                <td style={{ height: "11rem" }}>
                                                                    {firstItem.pet_photo_standing &&
                                                                        firstItem.pet_photo_standing.trim() !== "" ? (
                                                                        <img
                                                                            alt="Pet Image Standing"
                                                                            src={petPhotosStanding}
                                                                            style={{ width: "100%", height: "11rem" }}
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            alt="Not Found"
                                                                            src={images2} // Provide the URL for the "not found" image
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "11rem",
                                                                                opacity: "0.1",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </td>
                                                                <td style={{ height: "11rem" }}>
                                                                    {firstItem.pet_photo_sitting &&
                                                                        firstItem.pet_photo_sitting.trim() !== "" ? (
                                                                        <img
                                                                            alt="Pet Image sitting"
                                                                            src={petPhotosSitting}
                                                                            style={{ width: "100%", height: "11rem" }}
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            alt="Not Found"
                                                                            src={images2} // Provide the URL for the "not found" image
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "11rem",
                                                                                opacity: "0.1",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        name="Pet_Photo_Standing"
                                                                        onChange={handleFileChange}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        name="Pet_Photo_Sitting"
                                                                        onChange={handleFileChange}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {/* ----------view mode--------------- */}

                                        <div className="viewLeadDetails-form">
                                            <table
                                                style={{
                                                    width: "100%",
                                                    color: "#6A6A6A",
                                                    borderRadius: "5px",
                                                }}
                                            >
                                                <tr className="viewLeadDetailsHeading">
                                                    <th
                                                        colSpan={2}
                                                        style={{
                                                            background: "#5B489D",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        <span style={{ fontSize: "18px" }}>
                                                            {" "}
                                                            Customer Detail{" "}
                                                        </span>
                                                    </th>
                                                    <th
                                                        colSpan={2}
                                                        style={{
                                                            background: "#5B489D",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {" "}
                                                        <span style={{ fontSize: "18px" }}>Lead Detail </span>
                                                    </th>
                                                </tr>
                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Full Name</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.first_name}</span>
                                                    </td>
                                                    <th>
                                                        <span>Lead ID</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.relocation_id}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Gender</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.gender}</span>
                                                    </td>
                                                    <th>
                                                        <span>Lead Date</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.createddate}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Email ID</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.email}</span>
                                                    </td>
                                                    <th>
                                                        <span>Last Updated Date</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.modifieddate}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Mobile Number</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.mobile_no}</span>
                                                    </td>
                                                    <th>
                                                        <span>Lead Type</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.lead_region}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Service Type</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.servicetypename}</span>
                                                    </td>

                                                    <th>
                                                        <span>Lead Source</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.leadsource1}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Purpose of relocation</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.relocation_purpose}</span>
                                                    </td>

                                                    <th>
                                                        <span>Lead Status</span>
                                                    </th>
                                                    <td>
                                                        <span
                                                            style={{
                                                                color: "white",
                                                                fontWeight: "bold",
                                                                textAlign: "center",
                                                                backgroundColor: getStatusColor(
                                                                    leadDetailResponse.status_name
                                                                ),
                                                            }}
                                                        >
                                                            {" "}
                                                            &nbsp;
                                                            {leadDetailResponse.status_name} &nbsp;
                                                        </span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Find Where</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.from_where}</span>
                                                    </td>
                                                    <th>
                                                        <span>Current Lead Owner</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.name}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Alternate number</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.alternate_number}</span>
                                                    </td>
                                                    <th>
                                                        {" "}
                                                        <span>Previous Lead Owner</span>
                                                    </th>
                                                    <td>
                                                        {leadOwnerResponse.map((item, index) => (
                                                            <span
                                                                key={index}
                                                                onMouseEnter={(e) => handleMouseEnter(item, e)}
                                                                onMouseLeave={handleMouseLeave}
                                                                className={hoveredItem === item ? "highlight" : ""}
                                                                style={{ marginRight: "10px", cursor: "pointer" }}
                                                            >
                                                                {item.name}
                                                            </span>
                                                        ))}
                                                        {hoveredItem && (
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    marginTop: "10px",
                                                                    marginLeft: "10px",
                                                                    // top: `${tooltipPosition.top}px`,
                                                                    // left: `${tooltipPosition.left}px`,
                                                                    backgroundColor: "#000",
                                                                    border: "1px solid #ccc",
                                                                    padding: "10px",
                                                                    zIndex: 1000,
                                                                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                                                                    opacity: "60%",
                                                                    color: "white",
                                                                }}
                                                            >
                                                                <div>
                                                                    Assignment Detail: {hoveredItem.assignment_detail}
                                                                </div>
                                                                <div>Assigned On: {hoveredItem.assigned_on}</div>
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Scope of Work</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.job_type}</span>
                                                    </td>
                                                    <th><span>Ops Coordinator</span> </th>
                                                    <td><span>{leadDetailResponse.Assigned_By_Coordinator}</span></td>
                                                </tr>
                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>WhatsApp Title</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.whatsapp_title}</span>
                                                    </td>
                                                    <th>
                                                        <span>Lead Category</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="lead_label"
                                                            value={firstItem.lead_label}
                                                            disabled
                                                        >
                                                            <option value="0">Select an option</option>
                                                            {leadLabelResponse !== null &&
                                                                leadLabelResponse !== undefined &&
                                                                leadLabelResponse.length > 0 ? (
                                                                leadLabelResponse.map((item) => (
                                                                    <option value={item.label_id}>
                                                                        {item.label_name} {"(" + item.label_color + ")"}{" "}
                                                                    </option>
                                                                ))
                                                            ) : (
                                                                <option value="-1">NA</option>
                                                            )}
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>User ID</span>
                                                    </th>
                                                    <td>
                                                        <span>{firstItem.user_id}</span>
                                                    </td>
                                                    <th>
                                                        <span>Customer Type</span>
                                                    </th>
                                                    <td>
                                                        <span>{firstItem.customer_type}</span>
                                                    </td>
                                                </tr>


                                            </table>
                                        </div>
                                        <br />
                                        {/* ---------------------------Email Details---View------------------------------------------------------- */}
                                        {mailDetail.length > 0 && (
                                            <div className="viewLeadDetails-form">
                                                <table
                                                    style={{
                                                        width: "100%",
                                                        color: "#6A6A6A",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <tr className="viewLeadDetailsHeading">
                                                        <th
                                                            colSpan={4}
                                                            style={{
                                                                background: "#5B489D",
                                                                color: "white",
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            <span style={{ fontSize: "18px" }}>
                                                                {" "}
                                                                Email Detail{" "}
                                                            </span>
                                                        </th>
                                                    </tr>
                                                </table>
                                                <div style={{ maxHeight: "200px", overflowY: "scroll" }}>
                                                    <table
                                                        style={{
                                                            width: "100%",
                                                            color: "#6A6A6A",
                                                            borderRadius: "5px",
                                                        }}
                                                    >
                                                        <thead
                                                            className="viewLeadDetailsHeading"
                                                            style={{
                                                                position: "sticky",
                                                                top: "0",
                                                                zIndex: "1",
                                                                background: "#5B489D",
                                                                fontWeight: "bold",
                                                                fontSize: "16px",
                                                            }}
                                                        >
                                                            <tr>
                                                                <th
                                                                    style={{
                                                                        width: "41%",
                                                                        padding: " 0 10px 0 13px",
                                                                    }}
                                                                >
                                                                    Subject
                                                                </th>
                                                                <th style={{ width: "10%", fontSize: "14px" }}>
                                                                    Date & Time
                                                                </th>
                                                                <th>Sent or Receive By</th>
                                                                <th>Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {mailDetail.map((md, index) => (
                                                                <tr key={index} onClick={() => openModal(md)}>
                                                                    <td
                                                                        style={{
                                                                            width: "41%",
                                                                            padding: " 0 10px 0 13px",
                                                                        }}
                                                                    >
                                                                        <img
                                                                            style={{ height: "32px", width: "32px" }}
                                                                            src={mailIcon}
                                                                            alt="no img"
                                                                        />{" "}
                                                                        <span style={{ fontSize: "13px" }}>
                                                                            {md.subject}
                                                                        </span>
                                                                        <br />
                                                                        <span
                                                                            style={{
                                                                                fontSize: "13px",
                                                                                paddingLeft: "38px",
                                                                                width: "12%",
                                                                            }}
                                                                        >
                                                                            {md.fromAddress}
                                                                        </span>
                                                                    </td>
                                                                    <td style={{ width: "10%", fontSize: "14px" }}>
                                                                        {md.created_date}
                                                                    </td>
                                                                    <td style={{ fontSize: "13px" }}>{md.sender}</td>
                                                                    <td>Sent</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {isModalOpen && (
                                                    <div
                                                        style={{
                                                            position: "fixed",
                                                            top: "0",
                                                            left: "0",
                                                            width: "100%",
                                                            height: "100%",
                                                            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent black background
                                                            zIndex: 1000,
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                position: "fixed",
                                                                top: "50%",
                                                                left: "50%",
                                                                transform: "translate(-50%, -50%)",
                                                                zIndex: 1000,
                                                                backgroundColor: "rgba(255, 255, 255)", // Background color with opacity
                                                                padding: "20px",
                                                                borderRadius: "8px",
                                                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                                                width: "95%", // Increase the width
                                                                fontSize: "16px",
                                                                maxWidth: "800px", // Limit maximum width
                                                                border: "1px solid #e0e0e0", // Add border
                                                            }}
                                                        >
                                                            <button
                                                                onClick={closeModal}
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "3px",
                                                                    right: "3px",
                                                                    background: "none",
                                                                    border: "none",
                                                                    fontSize: "30px",
                                                                    cursor: "pointer",
                                                                    fontWeight: "bold",
                                                                    color: "#999999",
                                                                    width: "53px",
                                                                }}
                                                            >
                                                                &times;
                                                            </button>
                                                            {/* Your modal content here */}

                                                            <div style={{ paddingBottom: "1rem" }}>
                                                                <b
                                                                    style={{ fontSize: "20px", marginBottom: "1rem" }}
                                                                >
                                                                    {selectedMailDetail.subject}
                                                                </b>
                                                                <hr />
                                                                <div>
                                                                    <div style={{ marginBottom: "0.5rem" }}>
                                                                        <span style={{ fontWeight: "bold" }}>
                                                                            From:
                                                                        </span>{" "}
                                                                        <span>{selectedMailDetail.sender}</span>{" "}
                                                                        <span style={{ marginLeft: "1rem" }}>
                                                                            {selectedMailDetail.fromAddress}
                                                                        </span>
                                                                    </div>

                                                                    <div>
                                                                        <span style={{ fontWeight: "bold" }}>To:</span>{" "}
                                                                        <span>{selectedMailDetail.toAddress}</span>
                                                                    </div>
                                                                </div>
                                                                <hr />
                                                                <div
                                                                    style={{
                                                                        maxHeight: "300px",
                                                                        paddingTop: "1rem",
                                                                        fontSize: "16px",
                                                                        overflowY: "auto",
                                                                    }}
                                                                >
                                                                    {/*--------------Add your email body here*/}
                                                                    <p>{selectedMailDetail.summary}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        <br />
                                        {/* ---------------------------IVR Details---View------------------------------------------------------- */}

                                        <div className="viewLeadDetails-form">
                                            {ivrDetail.map((ivr, index) => (
                                                <table
                                                    style={{
                                                        width: "100%",
                                                        color: "#6A6A6A",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <tr className="viewLeadDetailsHeading">
                                                        <th
                                                            colSpan={4}
                                                            style={{
                                                                background: "#5B489D",
                                                                color: "white",
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            <span style={{ fontSize: "18px" }}> IVR Detail </span>
                                                        </th>
                                                    </tr>

                                                    <tr className="viewLeadDetailsHeading">
                                                        <th>
                                                            <span>Call ID</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.call_id}</span>
                                                        </td>
                                                        <th>
                                                            <span>Customer number</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.client_number}</span>
                                                        </td>
                                                    </tr>

                                                    <tr
                                                        style={{ width: "100%" }}
                                                        className="viewLeadDetailsHeading"
                                                    >
                                                        <th>
                                                            <span>Call Direction</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.direction}</span>
                                                        </td>
                                                        <th>
                                                            <span>Associate Name</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.agent_name}</span>
                                                        </td>
                                                    </tr>

                                                    <tr
                                                        style={{ width: "100%" }}
                                                        className="viewLeadDetailsHeading"
                                                    >
                                                        <th>
                                                            <span>Call Status</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.status}</span>
                                                        </td>
                                                        <th>
                                                            <span>Associate Number</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.agent_number}</span>
                                                        </td>
                                                    </tr>

                                                    <tr
                                                        style={{ width: "100%" }}
                                                        className="viewLeadDetailsHeading"
                                                    >
                                                        <th>
                                                            <span>Call Duration</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.call_duration}</span>
                                                        </td>
                                                        <th>
                                                            <span>Did Number</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.did_number}</span>
                                                        </td>
                                                    </tr>

                                                    <tr
                                                        style={{ width: "100%" }}
                                                        className="viewLeadDetailsHeading"
                                                    >
                                                        <th>
                                                            <span>Call Answered Seconds</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.answered_seconds}</span>
                                                        </td>
                                                        <th>
                                                            <span>Description</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.description}</span>
                                                        </td>
                                                    </tr>

                                                    <tr className="viewLeadDetailsHeading">
                                                        <th>
                                                            <span>Call End Time</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.end_stamp}</span>
                                                        </td>
                                                        <th>
                                                            <span>Department Name </span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.department_name}</span>
                                                        </td>
                                                    </tr>

                                                    <tr className="viewLeadDetailsHeading">
                                                        <th>
                                                            <span>Call Date</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.call_date}</span>
                                                        </td>
                                                        <th>
                                                            <span>Call Time</span>
                                                        </th>
                                                        <td>
                                                            <span>{ivr.call_time}</span>
                                                        </td>
                                                    </tr>
                                                    {canShow && (

                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>Recording URL</span>
                                                            </th>
                                                            <td colSpan={3}>
                                                                <span>
                                                                    {" "}
                                                                    <a
                                                                        href={ivr.description_url}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        {ivr.description_url}
                                                                    </a>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </table>
                                            ))}
                                        </div>
                                        <br />

                                        {/* --------------------------Relocation Details View---------------------------------------- */}

                                        <div className="viewLeadDetails-form">
                                            <table
                                                style={{
                                                    width: "100%",
                                                    color: "#6A6A6A",
                                                    borderRadius: "5px",
                                                }}
                                            >
                                                <tr className="viewLeadDetailsHeading">
                                                    <th
                                                        colSpan={4}
                                                        style={{
                                                            background: "#5B489D",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        <span style={{ fontSize: "18px" }}>
                                                            {" "}
                                                            Relocation Detail{" "}
                                                        </span>
                                                    </th>
                                                </tr>
                                                <tr
                                                    className="viewLeadDetailsHeading"
                                                    style={{ height: "3px" }}
                                                >
                                                    <td
                                                        colSpan={4}
                                                        style={{
                                                            background: "#ffffff",
                                                        }}
                                                    ></td>
                                                </tr>
                                                <tr className="viewLeadDetailsHeading">
                                                    <th
                                                        colSpan={2}
                                                        style={{
                                                            background: "#A3519F",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <span style={{ fontSize: "16px" }}> From </span>
                                                    </th>

                                                    <th
                                                        colSpan={2}
                                                        style={{
                                                            background: "#A3519F",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <span style={{ fontSize: "16px" }}> To </span>
                                                    </th>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>From Country</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.origin_country1}</span>
                                                    </td>
                                                    <th>
                                                        <span>To Country</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.destination_country1}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>From State</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.origin_state1}</span>
                                                    </td>
                                                    <th>
                                                        <span>To State</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.destination_state1}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>From City</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.origin_city1}</span>
                                                    </td>
                                                    <th>
                                                        <span>To City</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.destination_city1}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Pickup Address</span>
                                                    </th>
                                                    <td>
                                                        <span> {firstItem.origin_address} </span>
                                                    </td>
                                                    <th>
                                                        <span>Drop Address</span>
                                                    </th>
                                                    <td>
                                                        <span>{firstItem.destination_address} </span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Origin Pincode</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.origin_pin}</span>
                                                    </td>
                                                    <th>
                                                        <span>Destination Pincode</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.destination_pin}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Origin Port</span>
                                                    </th>
                                                    <td>
                                                        <span>{firstItem.origin_port}</span>
                                                    </td>
                                                    <th>
                                                        <span>Destination Port</span>
                                                    </th>
                                                    <td>
                                                        <span>{firstItem.destination_port}</span>
                                                    </td>
                                                </tr>



                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Sender Name</span>
                                                    </th>
                                                    <td>{firstItem.origin_contact_person}</td>
                                                    <th>
                                                        <span>Receiver Name</span>
                                                    </th>
                                                    <td>{firstItem.destination_contact_person}</td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Sender Contact Number</span>
                                                    </th>
                                                    <td>{firstItem.origin_contact_no}</td>
                                                    <th>
                                                        <span>Receiver Contact Number</span>
                                                    </th>
                                                    <td>{firstItem.destination_contact_no}</td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Relocation Date</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.relocation_date}</span>
                                                    </td>
                                                    <th>
                                                        <span>Lead Type</span>
                                                    </th>
                                                    <td>
                                                        <span>{leadDetailResponse.lead_region}</span>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Available Slots</span>
                                                    </th>
                                                    <td>
                                                        <span>{formatDate(firstItem.available_slot)}</span>
                                                    </td>
                                                    <th>
                                                        <span>Mode Of Transportation</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="mode_of_transport"
                                                            value={firstItem.mode_of_transport}
                                                            disabled
                                                        >
                                                            <option value="0">Please select</option>
                                                            <option value="1">Air </option>
                                                            <option value="2">Train </option>
                                                            <option value="3">Road </option>
                                                            <option value="4">NA</option>
                                                        </select>
                                                    </td>
                                                </tr>

                                                {firstItem.mode_of_transport.toString() === "2" ? (
                                                    <>
                                                        {/* --- Train-- View Mode*/}

                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>Delivery Type</span>
                                                            </th>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    name="delivery_type"
                                                                    disabled
                                                                    value={firstItem.delivery_type}
                                                                >
                                                                    <option value="0">Select an option</option>
                                                                    {deliveryTypeResponse.map((item) => (
                                                                        <option value={item.delivery_type_id}>
                                                                            {item.delivery_type_name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </td>
                                                            <th>
                                                                <span>Price</span>
                                                            </th>
                                                            <td>{firstItem.price}</td>
                                                        </tr>
                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>From City Code</span>
                                                            </th>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    name="origin_city_code"
                                                                    value={firstItem.origin_city_code}
                                                                    disabled
                                                                >
                                                                    <option value="0">Select an option</option>
                                                                    {originCityCodeResponse !== null &&
                                                                        originCityCodeResponse !== undefined &&
                                                                        originCityCodeResponse.length > 0 ? (
                                                                        originCityCodeResponse.map((item) => (
                                                                            <option value={item.code}>
                                                                                {item.name} {"(" + item.code + ")"}{" "}
                                                                            </option>
                                                                        ))
                                                                    ) : (
                                                                        <option value="-1">NA</option>
                                                                    )}
                                                                </select>
                                                            </td>
                                                            <th>
                                                                <span>To City Code</span>
                                                            </th>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    name="destination_city_code"
                                                                    value={firstItem.destination_city_code}
                                                                    disabled
                                                                >
                                                                    <option value="0">Select an option</option>
                                                                    {destinationCityCodeResponse !== null &&
                                                                        destinationCityCodeResponse !== undefined &&
                                                                        destinationCityCodeResponse.length > 0 ? (
                                                                        destinationCityCodeResponse.map((item) => (
                                                                            <option value={item.code}>
                                                                                {item.name} {"(" + item.code + ")"}
                                                                            </option>
                                                                        ))
                                                                    ) : (
                                                                        <option value="-1">NA</option>
                                                                    )}
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>Shipment Reference Number</span>
                                                            </th>
                                                            <td>
                                                                {firstItem.awb_number}
                                                            </td>
                                                            <th>
                                                                <span>Train Name & Number</span>
                                                            </th>
                                                            <td>
                                                                {firstItem.train_name_number}
                                                            </td>
                                                        </tr>
                                                    </>
                                                ) : (
                                                    <></>
                                                )}

                                                {firstItem.mode_of_transport.toString() === "1" ? (
                                                    <>
                                                        {/* ---Air -- View Mode*/}

                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>Delivery Type</span>
                                                            </th>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    name="delivery_type"
                                                                    disabled
                                                                    value={firstItem.delivery_type}
                                                                >
                                                                    <option value="0">Select an option</option>
                                                                    {deliveryTypeResponse.map((item) => (
                                                                        <option value={item.delivery_type_id}>
                                                                            {item.delivery_type_name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </td>
                                                            <th>
                                                                <span>Baggage Type</span>
                                                            </th>
                                                            <td>{firstItem.baggage_type}</td>
                                                        </tr>
                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>From Airport</span>
                                                            </th>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    name="origin_city_code"
                                                                    value={firstItem.origin_city_code}
                                                                    disabled
                                                                >
                                                                    <option value="0">Select an option</option>
                                                                    {originCityCodeResponse !== null &&
                                                                        originCityCodeResponse !== undefined &&
                                                                        originCityCodeResponse.length > 0 ? (
                                                                        originCityCodeResponse.map((item) => (
                                                                            <option value={item.code}>
                                                                                {item.name} {"(" + item.code + ")"}{" "}
                                                                            </option>
                                                                        ))
                                                                    ) : (
                                                                        <option value="-1">NA</option>
                                                                    )}
                                                                </select>
                                                            </td>
                                                            <th>
                                                                <span>To Airport</span>
                                                            </th>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    name="destination_city_code"
                                                                    value={firstItem.destination_city_code}
                                                                    disabled
                                                                >
                                                                    <option value="0">Select an option</option>
                                                                    {destinationCityCodeResponse !== null &&
                                                                        destinationCityCodeResponse !== undefined &&
                                                                        destinationCityCodeResponse.length > 0 ? (
                                                                        destinationCityCodeResponse.map((item) => (
                                                                            <option key={item.code} value={item.code}>
                                                                                {" "}
                                                                                {/* Added unique key */}
                                                                                {item.name} {"(" + item.code + ")"}
                                                                            </option>
                                                                        ))
                                                                    ) : (
                                                                        <option value="-1">NA</option>
                                                                    )}
                                                                </select>
                                                            </td>
                                                        </tr>

                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>Departure Time (Estimate)</span>
                                                            </th>
                                                            <td>{firstItem.departure_time}</td>
                                                            <th>
                                                                <span>Arrival Time (Estimate)</span>
                                                            </th>
                                                            <td>{firstItem.arrival_time}</td>
                                                        </tr>
                                                        <tr className="viewLeadDetailsHeading">
                                                            <th>
                                                                <span>AWB Number</span>
                                                            </th>
                                                            <td>
                                                                {firstItem.awb_number}
                                                            </td>
                                                            <th>
                                                                <span>Request Rate for Airlines</span>
                                                            </th>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    name="airlines_rate"
                                                                    value={firstItem.airlines_rate}
                                                                    disabled
                                                                >
                                                                    <option value="0">Select an option</option>
                                                                    {airlineNameResponse !== null &&
                                                                        airlineNameResponse !== undefined &&
                                                                        airlineNameResponse.length > 0 ? (
                                                                        airlineNameResponse.map((item) => (
                                                                            <option value={item.airline_id}>
                                                                                {item.airline_name}
                                                                            </option>
                                                                        ))
                                                                    ) : (
                                                                        <option value="-1">NA</option>
                                                                    )}
                                                                </select>
                                                            </td>
                                                        </tr>
                                                    </>
                                                ) : (
                                                    <></>
                                                )}
                                                <tr className="viewLeadDetailsHeading" style={{ display: "none" }}  >
                                                    <th>
                                                        <span>Relocation Detail</span>
                                                    </th>
                                                    <td colSpan={3}>{firstItem.relocation_detail}</td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading" style={{ display: "none" }}  >
                                                    <th>
                                                        <span>Pickup distance</span>
                                                    </th>
                                                    <td>{firstItem.distance}</td>
                                                    <th>
                                                        <span>Drop Distance</span>
                                                    </th>
                                                    <td>{firstItem.distance2}</td>
                                                </tr>
                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Airline Name</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="airline_id"
                                                            value={firstItem.airline_id}
                                                            disabled
                                                        >
                                                            <option value="0">Select an option</option>
                                                            {airlineNameResponse !== null &&
                                                                airlineNameResponse !== undefined &&
                                                                airlineNameResponse.length > 0 ? (
                                                                airlineNameResponse.map((item) => (
                                                                    <option value={item.airline_id}>
                                                                        {item.airline_name}
                                                                    </option>
                                                                ))
                                                            ) : (
                                                                <option value="-1">NA</option>
                                                            )}
                                                        </select>
                                                    </td>
                                                    <th>
                                                        <span>Flight Number</span>
                                                    </th>
                                                    <td>{firstItem.flight_number}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        {/* ------------------------------------------------------------------------------------------------ */}
                                        <br />
                                        <br />
                                        {/* --------------------------Pet Details View---------------------------------------- */}

                                        {petDetail.map((pet, index) => (
                                            <div className="viewLeadDetails-form">
                                                <table
                                                    style={{
                                                        width: "100%",
                                                        color: "#6A6A6A",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <tr className="viewLeadDetailsHeading">
                                                        <th
                                                            colSpan={4}
                                                            style={{
                                                                background: "#5B489D",
                                                                color: "white",
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            <span style={{ fontSize: "16px" }}> Pet Detail </span>
                                                        </th>
                                                    </tr>

                                                    <tr className="viewLeadDetailsHeading">
                                                        <th>
                                                            <span>Number of Pets</span>
                                                        </th>
                                                        <td>
                                                            <span>{leadDetailResponse.number_of_pets}</span>
                                                        </td>
                                                        <th>
                                                            <span>Pet Type</span>
                                                        </th>
                                                        <td>
                                                            <span>{pet.pettype}</span>
                                                        </td>
                                                    </tr>
                                                    <tr className="viewLeadDetailsHeading">
                                                        <th>
                                                            <span>Pet DOB | Pet Age</span>
                                                        </th>
                                                        <td>
                                                            <span>
                                                                {pet.pet_dob}{" "}
                                                                {pet.pet_dob && `(${calculateAge(pet.pet_dob)})`}
                                                            </span>
                                                        </td>

                                                        <th>
                                                            <span>Pet Breed</span>
                                                        </th>
                                                        <td>
                                                            <span>{pet.petbreedtype}</span>
                                                        </td>
                                                    </tr>

                                                    <tr className="viewLeadDetailsHeading">
                                                        <th>
                                                            <span>Pet Weight</span>
                                                        </th>
                                                        <td>
                                                            <span>{pet.pet_weight}</span>
                                                        </td>
                                                        <th>
                                                            <span>Pet Length (A)</span>
                                                        </th>
                                                        <td>
                                                            <span>{pet.pet_length}</span>
                                                        </td>
                                                    </tr>

                                                    <tr className="viewLeadDetailsHeading">
                                                        <th>
                                                            <span>
                                                                {" "}
                                                                Pet Height from ground to elbow joint (B)
                                                            </span>
                                                        </th>
                                                        <td>
                                                            <span>{pet.container_length}</span>
                                                        </td>
                                                        <th>
                                                            <span>Pet Width (C)</span>
                                                        </th>
                                                        <td>
                                                            <span>{pet.pet_width}</span>
                                                        </td>
                                                    </tr>

                                                    <tr className="viewLeadDetailsHeading">
                                                        <th>
                                                            <span>Pet Height (D)</span>
                                                        </th>
                                                        <td>
                                                            <span>{pet.pet_height}</span>
                                                        </td>
                                                        <th>
                                                            <span>Pet Measurement Link</span>
                                                        </th>
                                                        <td>
                                                            <a
                                                                href="https://www.carrymypet.com/pet-measurement"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                https://www.carrymypet.com/pet-measurement
                                                            </a>
                                                        </td>
                                                    </tr>
                                                    <tr className="viewLeadDetailsHeading">
                                                        <th>
                                                            <span>Pet Name</span>
                                                        </th>
                                                        <td>
                                                            <span> {pet.pet_name}</span>
                                                        </td>
                                                        <th>Recommended Crate Size</th>
                                                        <td>{crateSizeOptions[pet.crate_size] || pet.crate_size}</td>
                                                    </tr>
                                                    <tr className="viewLeadDetailsHeading">
                                                        <th>
                                                            <span>Applicable Chargeable Weight</span>
                                                        </th>
                                                        <td>
                                                            <span> {pet.chargeable_wt}</span>
                                                        </td>
                                                        <th>
                                                            <span>Rate</span>
                                                        </th>
                                                        <td>
                                                            <span> {pet.rate}</span>
                                                        </td>
                                                    </tr>


                                                </table>
                                            </div>
                                        ))}

                                        {/* ----------------------------Pet images View------------------------------------------------ */}
                                        <br />
                                        <br />

                                        <div className="viewLeadDetails-form">
                                            <table
                                                style={{
                                                    width: "100%",
                                                    color: "#6A6A6A",
                                                    borderRadius: "5px",
                                                }}
                                            >
                                                <tr className="viewLeadDetailsHeading">
                                                    <th
                                                        colSpan={2}
                                                        style={{
                                                            background: "#5B489D",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        <span style={{ fontSize: "16px" }}>
                                                            {" "}
                                                            Pet related Pictures{" "}
                                                        </span>
                                                    </th>
                                                </tr>
                                                <tr
                                                    className="viewLeadDetailsHeading"
                                                    style={{ height: "20px" }}
                                                >
                                                    <th
                                                        colSpan={2}
                                                        style={{
                                                            background: "#FFFFFF",
                                                        }}
                                                    ></th>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: "50%" }}>
                                                        <div
                                                            style={{
                                                                border: "1px solid #DEE2E6",
                                                                borderRadius: "1rem",
                                                            }}
                                                        >
                                                            <div className="pet-image-text-1">
                                                                <h4>Vaccination Book</h4>
                                                            </div>
                                                            <table style={{ width: "100%" }}>
                                                                <tr>
                                                                    <td style={{ height: "11rem", width: "50%" }}>
                                                                        {firstItem.vaccinationbook_front &&
                                                                            firstItem.vaccinationbook_front.trim() !==
                                                                            "" ? (
                                                                            <img
                                                                                alt="vaccination Book Front"
                                                                                src={vaccinationBookFront}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "11rem",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleImageClick(vaccinationBookFront)
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            <img
                                                                                alt="Not Found"
                                                                                src={images2}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "11rem",
                                                                                    opacity: "0.1",
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </td>
                                                                    <td style={{ height: "11rem", width: "50%" }}>
                                                                        {firstItem.vaccinationbook_back &&
                                                                            firstItem.vaccinationbook_back.trim() !== "" ? (
                                                                            <img
                                                                                alt="vaccination Book Back"
                                                                                src={vaccinationBookBack}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "11rem",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleImageClick(vaccinationBookBack)
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            <img
                                                                                alt="Not Found"
                                                                                src={images2}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "11rem",
                                                                                    opacity: "0.1",
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                    </td>
                                                    <td style={{ width: "50%" }}>
                                                        <div
                                                            style={{
                                                                border: "1px solid #DEE2E6",
                                                                borderRadius: "1rem",
                                                            }}
                                                        >
                                                            <h4 className="pet-image-text-2">Pet Photos</h4>
                                                            <table style={{ width: "100%" }}>
                                                                <tr>
                                                                    <td style={{ height: "11rem", width: "50%" }}>
                                                                        {firstItem.pet_photo_standing &&
                                                                            firstItem.pet_photo_standing.trim() !== "" ? (
                                                                            <img
                                                                                alt="pet Photos Standing"
                                                                                src={petPhotosStanding}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "11rem",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleImageClick(petPhotosStanding)
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            <img
                                                                                alt="Not Found"
                                                                                src={images2}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "11rem",
                                                                                    opacity: "0.1",
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </td>
                                                                    <td style={{ height: "11rem", width: "50%" }}>
                                                                        {firstItem.pet_photo_sitting &&
                                                                            firstItem.pet_photo_sitting.trim() !== "" ? (
                                                                            <img
                                                                                alt="pet Photos Sitting"
                                                                                src={petPhotosSitting}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "11rem",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleImageClick(petPhotosSitting)
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            <img
                                                                                alt="Not Found"
                                                                                src={images2}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "11rem",
                                                                                    opacity: "0.1",
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>

                                            {showModal && (
                                                <div className="modal" onClick={handleCloseModal}>
                                                    <span className="close" onClick={handleCloseModal}>
                                                        &times;
                                                    </span>
                                                    <img
                                                        className="modal-content"
                                                        src={selectedImage}
                                                        alt="Full Screen"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                            </Wrapper>
                            <br />
                            <form>
                                <Wrapper className="LeadDetails">
                                    {/* ----------------------------------Update Lead Information-------------------------------------- */}

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-end",
                                        }}
                                    >
                                        <div className="viewLeadDetails-form">
                                            <table
                                                style={{
                                                    width: "100%",
                                                    color: "#6A6A6A",
                                                    borderRadius: "5px",
                                                }}
                                            >
                                                <tr>
                                                    <td colSpan={4}>
                                                        <table style={{ width: "100%" }}>
                                                            <tr className="viewLeadDetailsHeading">
                                                                <th
                                                                    style={{
                                                                        background: "#5B489D",
                                                                        color: "white",
                                                                        fontWeight: "bold",
                                                                        width: "87%",
                                                                        borderRight: "1px solid white",
                                                                        borderTopRightRadius: "1px",
                                                                        borderBottomRightRadius: "1px",
                                                                    }}
                                                                >
                                                                    <span style={{ fontSize: "18px" }}>
                                                                        {" "}
                                                                        Update Lead Information{" "}
                                                                    </span>
                                                                </th>

                                                                <th
                                                                    style={{
                                                                        background: "#5B489D",
                                                                        color: "white",
                                                                        fontWeight: "bold",
                                                                        width: "12%",
                                                                        borderLeft: "1px solid white",
                                                                        borderTopLeftRadius: "1px",
                                                                        borderBottomLeftRadius: "1px",
                                                                    }}
                                                                >
                                                                    <span>Total Remarks - {leadUpdate.length}</span>
                                                                </th>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Next Follow-up Date/Time</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="datetime-local"
                                                            name="nextfollowupdatetime"
                                                            value={firstItem.nextfollowupdatetime}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange}
                                                        />
                                                    </td>
                                                    <th>
                                                        <span>Open Lead Stage</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="openleadstage"
                                                            value={firstItem.openleadstage}
                                                            onChange={handleChangeOPenClose}
                                                            disabled={isDisabled}
                                                        >
                                                            <option value="0">Select an option</option>
                                                            {openleadstageResponse !== null ? (
                                                                openleadstageResponse.map((item) => (
                                                                    <option value={item.stageid}>
                                                                        {item.stagename}
                                                                    </option>
                                                                ))
                                                            ) : (
                                                                <p>empty</p>
                                                            )}
                                                        </select>
                                                    </td>
                                                </tr>

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Close Lead Stage</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name="closedleadstage"
                                                            value={firstItem.closedleadstage}
                                                            onChange={handleChangeOPenClose}
                                                            disabled={isDisabled}
                                                        >
                                                            <option value="0">Select an option</option>
                                                            {closeleadstageResponse !== null ? (
                                                                closeleadstageResponse.map((item) => (
                                                                    <option value={item.stageid}>
                                                                        {item.stagename}
                                                                    </option>
                                                                ))
                                                            ) : (
                                                                <p>empty</p>
                                                            )}
                                                        </select>
                                                    </td>

                                                    <th>
                                                        <span>Sub Category</span>
                                                    </th>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            type="text"
                                                            name="sub_category"
                                                            value={firstItem.sub_category}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange}
                                                            disabled={isDisabled}
                                                        >
                                                            <option value="0">Select an option</option>
                                                            {subStageResponse !== null ? (
                                                                subStageResponse.map((item) => (
                                                                    <option value={item.substage_id}>
                                                                        {item.substage_name}
                                                                    </option>
                                                                ))
                                                            ) : (
                                                                <p>empty</p>
                                                            )}
                                                        </select>
                                                    </td>
                                                </tr>

                                                {isAdmin && (
                                                    <tr className="viewLeadDetailsHeading">
                                                        <th>
                                                            <span>Assign To</span>
                                                        </th>
                                                        <td>
                                                            <div
                                                                style={{ display: "flex", alignItems: "center" }}
                                                            >
                                                                <select
                                                                    style={{
                                                                        width: "100%",
                                                                        maxWidth: "24rem",
                                                                        marginRight: "1rem",
                                                                    }}
                                                                    className="form-control"
                                                                    name="assignto"
                                                                    onChange={handleChange}
                                                                    value={firstItem.assignto}
                                                                >
                                                                    <option value="0">Select an option</option>
                                                                    {assignToResponse.map((item, index) => (
                                                                        <option key={index} value={item.customer_id}>
                                                                            {item.name}
                                                                        </option>
                                                                    ))}
                                                                </select>

                                                                <button
                                                                    style={{
                                                                        height: "38px",
                                                                        width: "98px",
                                                                        marginLeft: "1rem",
                                                                    }}
                                                                    onClick={ChangeLeadOwner}
                                                                >
                                                                    Done
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <th>
                                                            <span>Converted Status</span>
                                                        </th>
                                                        <td>
                                                            <select
                                                                className="form-control"
                                                                name="convertedstatus"
                                                                value={firstItem.convertedstatus}
                                                                onChange={handleChange}
                                                            >
                                                                <option value="0">Select an option</option>
                                                                {convertedleadstageResponse !== null ? (
                                                                    convertedleadstageResponse.map(
                                                                        (item, index) => (
                                                                            <option key={index} value={item.stageid}>
                                                                                {item.stagename}
                                                                            </option>
                                                                        )
                                                                    )
                                                                ) : (
                                                                    <option disabled>Loading...</option>
                                                                )}
                                                            </select>
                                                        </td>
                                                    </tr>
                                                )}

                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Remark</span>
                                                    </th>
                                                    <td colSpan={3}>
                                                        <input
                                                            style={{ width: "99%" }}
                                                            className="form-control"
                                                            type="text"
                                                            name="remark"
                                                            value={firstItem.remark}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange}
                                                        />
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <br />
                                    <h3
                                        style={{
                                            marginTop: "1rem",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {" "}
                                        Lead Timeline
                                    </h3>
                                    <div
                                        style={{
                                            width: "100%",
                                            maxHeight: "300px",
                                            overflowY: "scroll",
                                            alignItems: "center",
                                        }}
                                    >
                                        <table
                                            className="customerDetailsTable"
                                            style={{ width: "99%", marginLeft: "5px" }}
                                        >
                                            {leadUpdate.map((remark, index) => (
                                                <div
                                                    className="wrapper undefined"
                                                    style={{ width: "100%" }}
                                                >
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            margin: "1rem",
                                                            padding: "1rem",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            <h3 className="card-title">
                                                                <b>Remark {leadUpdate.length - index} </b>{" "}
                                                            </h3>
                                                            <p className="card-text">
                                                                {" "}
                                                                <b> {remark.followupdate} </b>{" "}
                                                            </p>
                                                        </div>
                                                        <div className="row" style={{ padding: "11px 0 0 0" }}>
                                                            <div className="col-4">
                                                                <div className="card" style={{ width: "100%" }}>
                                                                    <div className="card-body">
                                                                        <p className="card-text">
                                                                            <b>Lead Stage</b>
                                                                            {remark.openleadstage_name !== null && (
                                                                                <span>
                                                                                    (Open) - {remark.openleadstage_name}
                                                                                </span>
                                                                            )}
                                                                            {remark.closedleadstage_name !== null && (
                                                                                <span>
                                                                                    (Close) - {remark.closedleadstage_name}
                                                                                </span>
                                                                            )}
                                                                            <span style={{ fontWeight: "bold" }}>
                                                                                - {remark.substage_name}
                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-4">
                                                                <div className="card" style={{ width: "100%" }}>
                                                                    <div className="card-body">
                                                                        <p className="card-text">
                                                                            <b>Lead Owner - </b>
                                                                            <span>{remark.assignto}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-4">
                                                                <div className="card" style={{ width: "100%" }}>
                                                                    <div className="card-body">
                                                                        <p className="card-text">
                                                                            <b>Next Follow Up Date/Time - </b>
                                                                            <span>{remark.nextfollowupdatetime}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="row"
                                                            style={{ padding: "11px 0 0 0", border: "none" }}
                                                        >
                                                            <div className="col-12">
                                                                <div
                                                                    className="card"
                                                                    style={{
                                                                        width: "100%",
                                                                        boeder: "none",
                                                                        background: "none",
                                                                    }}
                                                                >
                                                                    <div className="card-body">
                                                                        <p
                                                                            className="card-text"
                                                                            style={{
                                                                                fontSize: "14px",
                                                                                fontWeight: "bold",
                                                                            }}
                                                                        >
                                                                            {remark.remark}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </table>
                                    </div>
                                </Wrapper>
                                <br />
                                <Wrapper className="LeadDetails">
                                    {/* ----------------------------------submit Follow-Up Details-------------------------------- */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-end",
                                        }}
                                    >
                                        <div className="viewLeadDetails-form">
                                            <table
                                                style={{
                                                    width: "100%",
                                                    color: "#6A6A6A",
                                                    borderRadius: "5px",
                                                }}
                                            >
                                                <tr>
                                                    <td colSpan={4}>
                                                        <table style={{ width: "100%" }}>
                                                            <tr className="viewLeadDetailsHeading">
                                                                <th
                                                                    style={{
                                                                        background: "#5B489D",
                                                                        color: "white",
                                                                        fontWeight: "bold",
                                                                        width: "87%",
                                                                        borderRight: "1px solid white",
                                                                        borderTopRightRadius: "1px",
                                                                        borderBottomRightRadius: "1px",
                                                                    }}
                                                                >
                                                                    <span style={{ fontSize: "18px" }}>
                                                                        Submit Followup Details
                                                                    </span>
                                                                </th>

                                                                <th
                                                                    style={{
                                                                        background: "#5B489D",
                                                                        color: "white",
                                                                        fontWeight: "bold",
                                                                        width: "12%",
                                                                        borderLeft: "1px solid white",
                                                                        borderTopLeftRadius: "1px",
                                                                        borderBottomLeftRadius: "1px",
                                                                    }}
                                                                >
                                                                    <span>
                                                                        Total Follow-Up -{" "}
                                                                        {leadDetailResponse.total_followups}
                                                                    </span>
                                                                </th>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr className="viewLeadDetailsHeading">
                                                    <th>
                                                        <span>Follow-Up</span>
                                                    </th>
                                                    <td>
                                                        <input
                                                            style={{ width: "98%" }}
                                                            className="form-control"
                                                            type="text"
                                                            name="followup_remark"
                                                            value={firstItem.followup_remark}
                                                            placeholder="Please Enter*"
                                                            onChange={handleChange}
                                                        />
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <br />

                                    <h3
                                        style={{
                                            marginTop: "1rem",
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                        }}
                                    >
                                        {" "}
                                        Follow-Up Timeline
                                    </h3>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <div
                                            style={{
                                                width: "100%",
                                                overflowY: "auto",
                                                maxHeight: "200px",
                                            }}
                                        >
                                            <div style={{ width: "99%", marginLeft: "5px" }}>
                                                {followup.map((remark, index) => (
                                                    <Wrapper>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                margin: "1rem",
                                                                padding: "1rem",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    flexDirection: "row",
                                                                    justifyContent: "space-between",
                                                                }}
                                                            >
                                                                <h3
                                                                    className="card-title"
                                                                    style={{ fontWeight: "bold", fontSize: "16px" }}
                                                                >
                                                                    Follow-up {followup.length - index}
                                                                </h3>
                                                                <p className="card-text">{remark.followupdate}</p>
                                                            </div>
                                                            <p
                                                                className="card-text"
                                                                style={{ fontSize: "14px", fontWeight: "bold" }}
                                                            >
                                                                {" "}
                                                                {remark.remark}
                                                            </p>
                                                        </div>
                                                    </Wrapper>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Wrapper>
                                <br />
                                {canShow && (
                                    <div
                                        id="divSubmit"
                                        style={{ display: "flex", flexDirection: "row-reverse" }}
                                    >
                                        {decryptionError ? (
                                            <p>Error </p>
                                        ) : (
                                            <>
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary"
                                                    onClick={handleNextStep}
                                                    style={{ background: "white", color: "black" }}
                                                >
                                                    Go to Next Step
                                                </button>
                                                &nbsp;&nbsp;
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary"
                                                    onClick={handleClick}
                                                    style={{
                                                        background: `linear-gradient(to right, ${gradientColors.join(
                                                            ", "
                                                        )})`,
                                                    }}
                                                >
                                                    Update
                                                </button>

                                                &nbsp;&nbsp;

                                                {/* <button
                                                    type="submit"
                                                    className="btn btn-primary"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        showMandatoryFields();
                                                    }}
                                                    style={{
                                                        width: "200px",
                                                        background: `linear-gradient(to right, ${gradientColors.join(
                                                            ", "
                                                        )})`,
                                                    }}
                                                >
                                                    Show Mandatory Fields
                                                </button> */}
                                            </>
                                        )}
                                    </div>
                                )}
                            </form>
                        </div>

                    )}

                    {canShow && (
                        <>
                            {activeTab === "Documents" && <LeadDocuments Priority_upload={"2"} />}
                            {activeTab === "Payment Details" && (
                                <LeadPaymentDetails Relocation_Id={Relocation_ID} isEditMode={isEditMode} setIsEditMode={setIsEditMode} module="sales" />
                            )}
                            {activeTab === "Refund & Cancellation" && (
                                <LeadRefundDetails
                                    Relocation_Id={Relocation_ID}
                                    Customer_Name={leadDetailResponse.first_name}
                                    No_of_Pet={leadDetailResponse.number_of_pets}
                                    Pet_Name={petDetail.pet_name}
                                    Pet_Type={petDetail.pettype}
                                    Ops_Coordinator={leadDetailResponse.Assigned_By_Coordinator}
                                    module="sales"
                                />
                            )}
                            {activeTab === "Billing Details" && (
                                <LeadBillingDetails
                                    Relocation_Id={Relocation_ID}
                                />
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ViewLeadDetails;
